const messages = {
    uz: {
        main: {
            appName: 'БАХОЛАШ',
            search: 'Излаш',
            logOut: 'Чиқиш',
            number: '№',
            send: 'Жўнатиш',
            searchStatus: 'Статусни танланг',
            clearAllCaches: 'Cache тозалаш'
        },
        action: {
            saveAndCreateNew: 'Сақлаш ва янгисини яратиш',
            add: 'Қўшиш',
            view: 'Кўриш',
            edit: 'Ўзгартириш',
            delete: 'Ўчириш',
            save: 'Сақлаш',
            savePrice: 'Янги нархни киритиш',
            saveAndApprove: 'Сақлаш ва Тасдиқлаш',
            annul: 'Аннулировать',
            cancel: 'Бекор қилиш',
            next: 'Кейинги',
            prev: 'Олдинги',
            filter: 'Филтер',
            excel: 'Excel',
            draft: 'Қоралама',
            pay: 'Тулаш',
            sendSms: 'Смс жунатиш',
            enterBankLoginAndPassword: 'Банк Логин ва Парол киритинг',
            province: 'Вилоят',
            region: 'Туман',
            refresh: 'Янгилаш',
            addManually: 'Добавить вручную'
        },
        dropzone: {
            defaultMessage: 'Файлни юклаш учун бу ерга босинг!',
            maxFilesExceeded: 'Бошқа файлларни юклай олмайсиз.',
            cancelUpload: 'Бекор қилиш',
            cancelUploadConfirmation: 'Ҳақиқатан ҳам ушбу юклашни бекор қилмоқчимисиз?',
            removeFile: 'Ўчириш',
            removeFileConfirmation: 'Файлни ростдан ҳам ўчиришни хохлайсизми?'
        },
        company: {
            name: 'Компания',
            licenseAdd: 'Компанияга янги лицензия қўшиш',
            insuranceAdd: 'Компанияга янги суғурта қўшиш',
            certificateAdd: 'Компанияга янги сертификат қўшиш',
            preciousMetalsStonesAdd: 'Компанияга металлар ва қимматбаҳо учун лицензия қўшиш',
            add: {
                title: 'Компания профайли қўшиш'
            },
            edit: {
                title: 'Компания профайли ўзгартириш'
            },
            profile: {
                code: 'C',
                label: 'Компания профайли'
            },
            license: {
                code: 'CL',
                label: 'Компания лицензияси тўғрисида маълумот'
            },
            insurance: {
                code: 'CI',
                label: 'Компания суғуртаси тўғрисида маълумот'
            },
            certificate: {
                code: 'CС',
                label: 'Компания сертификати тўғрисида маълумот'
            },
            workingPreciousMetalsStones: {
                code: 'PMS',
                label: 'Қимматбаҳо металлар ва қимматбаҳо тошлар билан ишлаш учун лицензия'
            },
            validation: {
                name: 'Компания номини киритинг!',
                nameMaxLength: 'Компания номи 255 символдан ошмаслиги керак!',
                shortName: 'Компания қисқартирилган номини киритинг!',
                shortNameMax: 'Компания қисқартирилган номи 255 символдан ошмаслиги керак!',
                description: 'Компания таснифини киритинг!',
                descriptionMax: 'Компания таснифи 255 символдан ошмаслиги керак!',
                address: 'Компания манзилини киритинг!',
                addressMax: 'Компания манзили 255 символдан ошмаслиги керак!',
                phoneNumber: 'Компания телефон1ни киритинг!',
                phoneNumber1: 'Компания телефон1ни1 киритинг!',
                email: 'Е-майлни киритинг!',
                emailConfirm: 'Е-майлни форматини тугри киритинг!',
                webSite: 'Веб сахифасини киритинг!',
                accountNumber: 'Хисоб рақамини киритинг!',
                accountNumberConfirm: 'Хисоб рақам 20 символдан кам бўлмаслиги керак!',
                identificationNumber: 'ИНН рақамини киритинг!',
                identificationNumberConfirm: 'ИНН рақам 9 символдан кам бўлмаслиги керак!',
                interBranchTurnover: 'МФО рақамини киритинг!',
                interBranchTurnoverConfirm: 'МФО рақам 5 символдан кам бўлмаслиги керак!',
                xxtut: 'ХХТУТ рақамини киритинг!',
                xxtutConfirm: 'ХХТУТ рақам 5 символдан кам бўлмаслиги керак!',
                bankName: 'Банк номини киритинг!',
                director: 'Илтимос директорни танланг!',
                regNum: 'Регистрация рақамини киритинг!',
                regNumConfirm: 'Регистрация рақами 255 символдан ошмаслиги керак!',
                serialNum: 'Хисоб сериясини киритинг!',
                serialNumConfirm: 'Хисоб серияси 255 символдан ошмаслиги керак!',
                dataNum: 'Рақамини киритинг!',
                dataNumConfirm: 'Рақами 255 символдан ошмаслиги керак!',
                giveName: 'Ким тамонидан берилганни киритинг!',
                giveNameConfirm: 'Ким тамонидан берилган 255 символдан ошмаслиги керак!',
                startDate: 'Берилган санасини киритинг!',
                endDate: 'Амал қилиш муддатини киритинг!',
                province: 'Вилоятни танланг!',
                region: 'Туманни танланг!',
            },
            field: {
                docCompanyLogo: 'Компания Logo',
                name: 'Компания номи',
                shortName: 'Компания қисқартирилган номи',
                nameRu: 'Компания номи (RU)',
                description: 'Компания таснифи',
                address: 'Компания манзили',
                phoneNumber1: 'Компания телефон1',
                phoneNumber2: 'Компания телефон2',
                email: 'Е-майл',
                webSite: 'Веб сахифаси',
                accountNumber: 'Хисоб рақами',
                identificationNumber: 'ИНН',
                interBranchTurnover: 'МФО',
                xxtut: 'ХХТУТ',
                bankName: 'Банк номи',
                director: 'Директор',
                docCompanyCertificate: 'Гувохнома нусхасини юкланг',
                hasEsp: 'ЭЦП (Ҳа / Йўқ)',
                companyEdit: 'Ўзгартириш',
                companyAdd: 'Қўшиш',
                companyCreate: 'Янгидан қўшиш',
                companyCertificatePicture: 'Гувохнома нусхасини юкланг',
                regNum: 'Регистрация рақами',
                serialNum: 'Хисоб серияси',
                dataNum: 'Рақами',
                giveName: 'Ким тамонидан берилган',
                startDate: 'Берилган санаси',
                endDate: 'Амал қилиш муддати',
                companyLicensePicture: 'Лицензия нусхасини юкланг',
                companyInsurancePicture: 'Суғурта нусхасини юкланг',
                companyCertificatePictureFile: 'Сертификати нусхасини юкланг',
                leaderStartDate: 'Директор бўлган санаси',
                preciousMetalsStonesPicture: 'Қимматбаҳо металлар ва қимматбаҳо тошлар билан ишлаш учун лицензия нусхасини юкланг',
                province: 'Вилоят',
                region: 'Туман',
                qqs: 'ККС (Ҳа / Йўқ)'
            }
        },
        client: {
            name: 'Мижозлар',
            titleListPhysical: 'Жисмоний шахслар рўйхати',
            titleListLegal: 'Юридик шахслар рўйхати',
            titleAddEditPhysical: 'Жисмоний шахс маълумотлари',
            titleAddEditLegal: 'Юридик шахс маълумотлари',
            titleEditView: 'Мижоз маълумотлари',
            add: {
                titlePhysical: 'Жисмоний шахс маълумотларини киритинг',
                titleLegal: 'Юридик шахс маълумотларини киритинг'
            },
            physical: {
                code: 'P',
                label: 'Жисмоний шахс'
            },
            legal: {
                code: 'L',
                label: 'Юридик шахс'
            },
            action: {
                addApi: 'Қўшиш янги (паспорт)'
            },
            field: {
                fullName: 'Ф.И.Ш',
                address: 'Манзили',
                clientType: 'Тоифаси',
                createdDate: 'Киритилган сана',
                updatedDate: 'Ўзгартирилган сана',
                createdBy: 'Томонидан яратилган',
                action: 'Жараён',
                lastName: 'Фамилияси',
                firstName: 'Исми',
                midName: 'Отасининг исми',
                province: 'Вилояти',
                region: 'Тумани',
                phone: 'Телефон рақами',
                passportNumber: 'Паспорт серияси ва рақами',
                passportDate: 'Паспорт берилган сана',
                passportGivePlace: 'Ким томондан берилган',
                organizationType: 'Ташкилот',
                bankType: 'Банк тури',
                departmentType: 'Бошқарма тури',
                lLastName: 'Рахбарнинг фамилияси',
                lFirstName: 'Рахбарнинг исми',
                lMidName: 'Рахбар отасининг исми',
                firmName: 'Ташкилот номи',
                position: 'Лавозими',
                lAddress: 'Ташкилот манзили',
                accountNumber: 'Хисоб рақами',
                identificationNumber: 'ИНН',
                mFO: 'МФО',
                bankMFOName: 'Банк номи',
                email: 'Е-майл',
                soleTaxPayer: 'Ягона солиқ тўловчи',
                allowedAreas: 'Рухсат этилган худудлар',
                birthDate: 'Мижоз тўғилган санаси',
                passportDateValid: 'Паспорт амал қилиш муддати',
                pinflNumber: 'Жисмоний шаҳснинг шаҳсий идентификация рақами (ЖШШИР 14 рақам)'
            },
            validation: {
                lastName: 'Фамилиясини киритинг!',
                firstName: 'Исмини киритинг!',
                midName: 'Отасини исмини киритинг!',
                firmName: 'Ташкилот номини киритинг!',
                province: 'Вилоятни танланг!',
                region: 'Туманни танланг!',
                phone: 'Телефон рақамини киритинг!',
                pinflNumber: 'ЖШШИР формати хато!',
                passportNumber: 'Паспорт серияси ва рақамини киритинг!',
                passportDate: 'Паспорт берилган санани киритинг!',
                passportGivePlace: 'Ким томондан берилганни киритинг!',
                address: 'Манзилини киритинг!',
                minText: 'Ушбу майдон камида ',
                minValid: ' та белгидан иборат бўлиш керак!',
                maxText: 'Ушбу майдон ',
                maxValid: ' та белгидан иборат бўлиш керак!',
                accountNumber: 'Хисоб рақамини киритинг!',
                identificationNumber: 'ИННни киритинг!',
                mFO: 'МФО ни киритинг!',
                bankMFOName: 'Банк номини киритинг!',
                email: 'Е-майлни киритинг!',
                organizationType: 'Ташкилотни танланг!',
                bankType: 'Банк турини танланг!',
                departmentType: 'Бошқарма турини танланг!',
                position: 'Лавозимини киритинг!',
                birthDate: 'Мижоз тўғилган санасини киритинг!',
                passportDateValid: 'Паспорт амал қилиш муддатини киритинг!'
            }
        },
        user: {
            list: {
                code: 'Ф',
                label: 'Фойдаланувчилар'
            },
            listTitle: "Фойдаланувчилар рўйхати",
            addNew: "Фойдаланувчи қўшиш",
            titleEdit: 'Фойдаланувчини ўзгартириш',
            viewUserInfo: 'Фойдаланувчи маълумотлари кўриш',
            editUserInfo: 'Фойдаланувчи маълумотлари ўзгартириш',
            addUserInfo: 'Фойдаланувчи маълумотлари қўшиш ',
            name: 'Фойдаланувчилар',
            field: {
                fullName: 'Ф.И.О',
                lastName: 'Фамилия',
                firstName: 'Исми',
                midName: 'Отасининг исми',
                dateOfBirth: 'Тўғилган санаси',
                address: 'Манзил',
                province: 'Вилояти',
                region: 'Тумани',
                email: 'Е-майл',
                mobilePhone: 'Мобил телефон',
                homePhone: 'Уй телефон',
                pinflNumber: 'Жисмоний шахсларнинг шахсий идентификация рақами (ПИНФЛ 14 РАҚАМ)',
                password: 'Хозирги парол',
                newPassword: 'Янги парол',
                passwordConfirm: 'Янги паролни такроран',
                administrationType: 'Бошқарма тури',
                username: 'Логин',
                identificationNumber: "ИНН",
                theEmployeesServiceOrganization: 'Ходимнинг хизмат курсатиш ташкилоти:',
                roleNames: 'Мансаби',
                userProvinces: 'Менежерга бириктирилган вилоят',
                info: "Изох",
                status: 'Статус',
                toAdd: 'Кўшиш',
                attachRegionsToTheManager: 'Менеджерга вилоятлар бириктириш',
            },
            validation: {
                lastName: 'Фамилиясини киритинг!',
                firstName: 'Исмини киритинг!',
                midName: 'Отасини исмини киритинг!',
                dateOfBirth: 'Тўғилган санасини киритинг!',
                address: 'Манзилини киритинг!',
                province: 'Вилоятни танланг!',
                region: 'Туманни танланг!',
                email: 'Е-майлни киритинг!',
                homePhone: 'Уй телефон киритинг!',
                mobilePhone: 'Мобил телефон киритинг!',
                pinflNumber: 'ПИНФЛ форматида хатолик!',
                password:'Хозирги парол киритинг',
                newPassword:'Янги парол киритинг',
                passwordConfirm:'Янги паролни такрорлан',
                username: 'Логин киритинг!',
                identificationNumber: 'ИННни киритинг!',
                administrationType: 'Бошқарма турини киритинг!',
                theEmployeesServiceOrganization: 'Ходимнинг хизмат курсатиш ташкилотини танланг!',
                info: "Изох ёзинг",
                serialNum: 'Хисоб сериясини киритинг!',
                dataNum: 'Рақамини киритинг!',
                beginDate: 'Сана(дан) танланг',
                endDate: 'Сана(гача) танланг',
                giveName: 'Ким тамонидан берилганни киритинг!',
            }
        },
        realEstate: {
            name: 'Кўчмас мулк',
            titleList: 'Кўчмас мулклар рўйхати',
            titleListNotorious: 'Кўчмас мулклар рўйхати (Нотурар жой)',
            titleListResidential: 'Кўчмас мулклар рўйхати (Турар жой)',
            titleAddEdit: 'Кўчмас мулкни бахолаш',
            titleAddEditNotorious: 'Кўчмас мулкни бахолаш (Нотурар жой)',
            titleAddEditResidential: 'Кўчмас мулкни бахолаш (Турар жой)',
            titleEAppraisalRealEstateView: 'Е-баҳолаш кўчмас мулкни куриш',
            add: {
                title: 'Кўчмас мулк маълумотларини киритинг'
            },
            edit: {
                title: 'Кўчмас мулкни ўзгартириш'
            },
            view: {
                title: 'Кўчмас мулкни куриш',
                eAppraisalTitle: ' E-Баҳолаш: Кўчмас мулк умумий маъмумотлари'
            },
            delete: {
                title: 'Ўчириш'
            },
            report: {
                title: 'Ҳисобот PDF',
                titleQrCode: "Ҳисобот PDF QR Code",
                titleWord: "Ҳисобот Word",
                titleWordQrCode: "Ҳисобот Word QR Code",
                titleContractWord: "Шартнома Word",
                titleContractWordQrCode: "Шартнома Word QR Code",
                titleContractPdf: "Шартнома Pdf",
                titleContractPdfQrCode: "Шартнома Pdf QR Code",
                reportNotSignedAndNoQrCodesPdf: "Ҳисобот PDF(бошқа)"
            },
            field: {
                name: 'Объект',
                ownerClient: 'Мулк эгаси',
                address: 'Манзили',
                addressAddEdit: 'Кўчмас мулк манзили',
                approachMethods: 'Ёндашув усуллари',
                regPlace: 'Рег жойи',
                evaluatedAmount: 'Бахоланган суммаси',
                status: 'Статус',
                createdDate: 'Киритилган сана',
                createdByAndDate: 'Яратилган / Киритилган сана',
                createdBy: 'Томонидан яратилган',
                action: 'Жараён',
                withLetterOfAttorney: 'Ишончнома билан / Бошқа ташкилот буюртмаси қатнашяптими',
                withLetterOfAttorneyOwner: 'Ишончнома билан / Бошқа ташкилот буюртмаси эгаси',
                evaluationPurpose: 'Бахолаш мақсади',
                evaluationRespectiveType: 'Тегишли мулкни тури',
                cadastreNumber: 'Кўчмас мулк кадастр рақами',
                cadastreSection: 'Кадастр иншоатлари турини танланг',
                province: 'Вилоятни танланг',
                region: 'Туманни танланг',
                mibDebtorName: 'Қарздор номи',
                mibLetterNumber: 'Мурожаат хати номери',
                mibLetterDate: 'Мурожаат хати санаси',
                mibRegion: 'Мажбурий ижро бюросининг вилоят бўлими',
                areaTotal: 'Кўчмас мулк умумий ер майдони(кв. м)',
                areaUnderConstruction: 'Кўчмас мулк умумий қурилиш ости майдони(кв. м)',
                areaUseful: 'Кўчмас мулк умумий фойдали майдон(кв. м)',
                valueType: 'Кўчмас мулкни аниқланаётган қиймат турини танланг',
                propertyType: 'Мулкчилик шакли',
                evaluator: 'Бахоловчи',
                evaluatorEspConfirmed: 'Бахоловчи ESP билан тасдиқлаган',
                director: 'Директор',
                directorEspConfirmed: 'Директор ESP билан тасдиқлаган',
                contractAmount: 'Контракт суммаси',
                landComparison: 'Ер участкаси бозор кийматини хисоблаш (қиёсий йўл билан)',
                landCapitalization: 'Ер участкаси бозор кийматини хисоблаш (ер солиги ставкасининг капиталлаштириш йўли билан)',
                landCapitalizationTitle: 'Ер участкаси бозор кийматини копиталлаштириш усулида ҳисоблаш',
                docsToSubmit: 'Кўчмас мулкни бахолаш учун тақдим қилинадиган хужжатлар',
                docPassport: 'Паспорт нусхаси',
                docActOfSale: 'Далолатнома',
                docDecision: 'Карор нусхаси',
                docPlaylist: 'Ижро варакаси',
                docBalance: 'Баланс тугрисида маълумот',
                docCadastre: 'Кадастр хужжати',
                docApplication: 'Ариза',
                docDocuments: 'Мурожат хати',
                docBuildingPhotos: 'Бино расмлари',
                docPrivatizationLetter: 'Кумитанинг бахолаш тугрисида хати',
                docPrivatizationCommissionOrder: 'Хусусийлаштириш комиссиясининг буйрук ва протоколлари',
                docOwnershipCertificate: 'Эгалик хукукини тасдикловчи гувохнома',
                buildingsToEvaluate: 'Баҳоланадиган биноларни киритинг',
                addBuilding: 'Бино қўшиш',
                checkPaymentFiles: 'Далолатнома,Счет фактура,Шартнома ва Вазифалар',
                checkPaymentFilesMib: 'Далолатнома ва Счет фактура',
                evaluatorIdea: 'Идентификация бўйича баҳоловчи фикри',
                evaluatorRestrictiveTerms: 'Чекловчи шартлар бўйича баҳоловчи фикри',
                category: 'Категорияси',
                docsSubmitted: 'Кўчмас мулкни бахолаш учун тақдим қилинган хужжатлар',
                buildingDocsSubmitted: 'Биноларни бахолаш учун тақдим қилинган хужжатлар',
                rejectText: 'Бекор қилиш сабаби',
                locationText: 'Жойлашган жойи',
                letterNumberText: 'Хат №: ',
                invoiceNumberText: 'Шартнома №: ',
                reportNumberText: 'Хисобот №: ',
                buildingCategory: 'Кўчмас мулк турини танланг',
                basicInformation: 'Кўчмас мулк асосий маълумотлари ',
                buildingType: 'Фойдаланиш мақсади',
                microRegion: 'Мулжални танланг',
                repairConditions: 'Таъмир холати',
                constructiveElement: 'Қурилиш тури',
                storey: 'Қаватлари сони',
                floor: 'Қавати',
                builtYear: 'Қурилган йили',
                ownerPhoneNumber: 'Мулк эгасининг телефон рақами',
                agent: 'Агент',
                specialComfort: 'Алохида кулайликлар',
                constructionCompletion: 'Курилиш тугалланганлиги (%)',
                architecturalStyle: 'Архитектуравий услуб (Фасад)',
                tenderContractDate: 'Шартнома санаси',
                tenderContractNumber: 'Рақами №',
                separateBuilding: 'Алоҳида қурилган бино',
                admin: 'Администратор',
                area: 'Майдони',
                isFixByIndexLabel: 'Киёсий ёндашув индекс буйича тузатиш бериш',
                transportPlace: 'Автотураргоҳ мавжудлиги',
                ownerName: 'Мулк эгаси',
                ownerInn: 'Мулк эгаси ИНН',
                landLeaseEnabled: 'Ер участкаси ижара ҳуқуқининг қийматини хисоблаш',
                powerOfAttorneyNumber: 'Ишончнома рақами',
                powerOfAttorneyDate: 'Ишончнома санаси',
                landOwnerEnabled: 'Ер участкасига эгалик хукуки мавжуд эмас',
                housingType: ' тури',
                percentage: 'Фоиз',
                constructionCompletionDoc: 'Қурилиш тугаланганлик фоизи кўрсатилган ҳужжатни юкланг',
                evlTotalArea: 'Кўчмас мулк умумий майдон(кв. м)',
                hasTotalArea: 'Умумий майдондан хисоблаш',
                ownerPinflOrInn: 'Мулк эгаси ЖШШИР ёки ИНН киритинг'
            },
            reloadDataByCadastre: {
                title: 'Квартира кадастр рақамини тўлиқ киритинг',
                example: 'Намуна',
                withAllFloors: 'Кўп-қаватли турар жой барча қавартиралар билан'
            },
            category: {
                notorious: {
                    code: 'Н',
                    label: 'Нотурар жой'
                },
                residential: {
                    code: 'Т',
                    label: 'Турар жой'
                }
            },
            plus: {
                category: {
                    notorious: {
                        code: 'Н(+)',
                        label: 'Нотурар жой (Баҳолаш плюс)'
                    },
                    residential: {
                        code: 'Т(+)',
                        label: 'Турар жой (Баҳолаш плюс)'
                    }
                },
                sendFixError: {
                    title: 'Камчиликга юбориш',
                    description: 'Камчилик сабабини киритинг.',
                    upload: 'Камчиликни юклаш'
                }
            },
            approach: {
                expense: 'Харажат ёндашув',
                income: 'Даромад ёндашув',
                comparative: 'Қиёсий ёндашув',
                regression: 'Регрессион ёндашув',
                newComparative: 'Янги қиёсий ёндашув'
            },
            createType: {
                ourselves: 'Ўзимизда',
                online: 'E-Baxolash сайти',
                android: 'Android',
                apiMib: 'API MIB',
                api_bank: 'API BANK',
                api_backend: 'API BACKEND',
                api_online: 'API ONLINE',
                api_exarid: 'API E-XARID',
                expert2: 'Эксперт 2',
                online_plus: 'E-Baxolash +',
                real_soft: 'Real Soft',
                apiEMonitoring: 'E-Мониторинг'
            },
            status: {
                notReady: 'Тайёр эмас',
                pending: 'Хали кўрилмади',
                assignedToEvaluator: 'Бахоловчига бириктирилди',
                notFullyEvaluated: 'Бахолаш жараёнида',
                evaluated: 'Бахоланган',
                confirmed: 'Тасдиқланган',
                rejected: 'Бекор қилинган',
                sentToComplement: 'Тўлдирувчига бириктирилди',
                inIdentification: 'Идентификацияда',
                errorInPrice: 'Нархда хатолик',
                open: 'Янги',
                inCorrection: 'База камчиликга юборилди'
            },
            valueType: {
                market: 'Бозор қиймати',
                nonMarket: 'Бозордан фаркли киймат'
            },
            validation: {
                name: 'Илтимос объект номини киритинг',
                ownerClient: 'Илтимос мулк эгасини танланг',
                withLetterOfAttorneyOwner: 'Илтимос бошқа ташкилот буюртмаси эгасини танланг',
                approachMethods: 'Илтимос ёндашув усул(лар)ини танланг',
                evaluationPurpose: 'Илтимос бахолаш мақсадини танланг',
                cadastreNumber: 'Илтимос кўчмас мулк кадастр рақамини киритинг',
                cadastreSection: 'Илтимос кадастр иншоатлари турини танланг',
                province: 'Илтимос вилоятни танланг',
                region: 'Илтимос туманни танланг',
                addressAddEdit: 'Илтимос кўчмас мулк манзилини киритинг',
                mibDebtorName: 'Илтимос қарздор номини киритинг',
                mibLetterNumber: 'Илтимос мурожаат хати номерини киритинг',
                mibLetterDate: 'Илтимос мурожаат хати санасини танланг',
                areaTotal: 'Илтимос кўчмас мулк умумий ер майдонини киритинг',
                areaUnderConstruction: 'Илтимос кўчмас мулк қурилиш ости майдонини киритинг',
                areaUseful: 'Илтимос кўчмас мулк фойдали майдонини киритинг',
                valueType: 'Илтимос қиймат турини танланг',
                propertyType: 'Илтимос қиймат турини танланг',
                evaluator: 'Илтимос қиймат турини танланг',
                evaluationRespectiveType: 'Илтимос тегишли мулкнинг турини танланг',
                cadastreSectionEdit: {
                    code: 'Илтимос кодни киритинг',
                    nameUz: 'Илтимос текстни киритинг',
                    nameRu: 'Илтимос текст(ru)ни киритинг'
                },
                cadastreBuildingEdit: {
                    section: 'Илтимос кадастр иншоат турини танланг',
                    code: 'Илтимос кодни киритинг',
                    nameUz: 'Илтимос текстни киритинг',
                    nameRu: 'Илтимос текст(ru)ни киритинг',
                    recoveryField: 'Илтимос тикланиш қийматини танланг',
                    capitalGroup: 'Илтимос капиталлик гурухини танланг'
                },
                cadastreBuildingFieldEdit: {
                    code: 'Илтимос кодни киритинг',
                    nameUz: 'Илтимос текстни киритинг',
                    nameRu: 'Илтимос текст(ru)ни киритинг'
                },
                cadastreBuildingDepreciationFieldEdit: {
                    code: 'Илтимос кодни киритинг',
                    nameUz: 'Илтимос текстни киритинг',
                    nameRu: 'Илтимос текст(ru)ни киритинг'
                },
                cadastreBuildingFieldReferenceEdit: {
                    code: 'Илтимос кодни киритинг',
                    nameUz: 'Илтимос текстни киритинг',
                    nameRu: 'Илтимос текст(ru)ни киритинг'
                },
                reasonDesc: 'Илтимос бекор килиш сабабини киритинг',
                evlContractAmount: 'Илтимос кантракт суммани киритинг',
                realEstateDocs: 'Хужжатларни юкланг!',
                taxType: 'Тури',
                configAmount: 'Қиймати',
                evlTotalArea: 'Илтимос кўчмас мулк умумий майдонини киритинг'
            },
            land: {
                title: 'Кўчмас мулк - Ер участкаси бозор кийматини хисоблаш'
            },
            coordination: {
                title: 'Кўчмас мулкни мувофиқлаштириш'
            },
            action: {
                evaluate: 'Бахолашни тугатиш',
                confirm: 'Тасдиқлаш',
                reevaluate: 'Қайта бахолаш',
                pending: 'Бекор қилиш',
                espSign: 'ЭЦП имзолаш',
                bindAppraiser: 'Баҳоловчига бериш',
                sendReportToMIB: 'Хисоботни МИБ га жўнатиш',
                evaluationAnalogGet: 'Бахолаш',
                appraiserEspSign: 'Баҳоловчи ЭЦП имзолаш',
                submitForEvaluation: 'Баҳолашга жунатиш',
                bindAgent: 'Агентга бериш',
                evlComparativeReference: 'Маълумотнома PDF',
                bindComplement: 'Тўлдирувчига бериш'
            },
            esp: {
                title: 'Кучмас мулкни ЭЦП орқали имзолаш',
                invoice: 'Хисоб варак фактурага ЭЦП имзо куйиш',
                invoiceEspInfo: '(Имзо куйишдан олдин Хисоб варак фактура билан танишиб чикинг)',
                report: 'Хисоботга ЭЦП имзо куйиш',
                reportEspInfo: '(Имзо куйишдан олдин хисобот билан танишиб чикинг!)',
                reportDownload: 'Илтимос кутинг ҳисобот юкланмокда!',
                contractDownload: 'Илтимос кутинг шартнома юкланмокда!'
            },
            appraiserReportEsp: {
                title: 'Кучмас мулкни бахоловчи ЭЦП орқали имзолаш',
                report: 'Ҳисоботга бахоловчи ЭЦП оркали имзо куйиш',
                reportEspInfo: '(Имзо куйишдан олдин хисобот билан танишиб чикинг!)',
                field: {
                    selectEsp: 'Электрон калитни танланг'
                }
            },
            regression: {
                action: {
                    addCategories: 'Уй жой категория'
                }
            },
            cadastreDetails: {
                title: 'Кадастр маълумотлари',
                buildingSectionTypeValue: "Категория",
                province: "Вилоят",
                region: "Туман",
                mfyName: "Маҳалла",
                streetName: "Кўча",
                address: "Манзил",
                cadastreNumber: "Уй кадастр рақами",
                owner: "Субъект",
                totalUsableArea: 'Умумий майдони',
                floor: "Қавати",
                floorNumber: "Қаватлилиги",
                landArea: "Умумий ер майдони",
                buildingArea: "Қурулиш ости майдони",
                infoText: "Агар маълумотларда хатолик аниқланса \"Янгилаш\" тугмаси босилсин"
            },
            mapStatus: {
                open: 'Янги',
                pending: 'Кутиляпти',
                reject: 'Бекор қилинди',
                done: 'Тузатилди',
                inProgress: 'Жараёнда'
            }
        },
        building: {
            titleAddEdit: 'Кўчмас мулк биноси',
            edit: {
                title: 'Кўчмас мулкдаги бинонинг маълумотларини киритинг'
            },
            field: {
                buildingType: 'Бино турини танланг',
                buildingTypeCategory: 'Бино тури категорияси',
                name: 'Бино номи',
                madeYear: 'Бино қурилган йили',
                floors: 'Бино қаватлари сони',
                area: 'Бино қурилиш ости майдони (м2)',
                height: 'Бино умумий баландлиги (м)',
                heightInner: 'Бино ички баландлиги (м)',
                volume: 'Бино хажми (м3)',
                earthquakePoint: 'Зилзилага бардошлилик коэфициенти',
                businessCoefficient: 'Тадбиркорлик коэфициенти',
                foundation: 'Бино пойдевори',
                wall: 'Бино девори',
                roofCloseType: 'Бино томи ёпилиш усули',
                floorsMiddleType: 'Бино қаватлари ораси',
                floorType: 'Бино поли',
                doorsAndWindows: 'Эшик ва деразалар',
                halfTimerFrame: 'Заполнение фахверка каркасных стен',
                standsAndColumns: 'Таянч ва устунлар',
                additionalValues: 'Қўшимча қийматлар',
                depreciation: 'Жисмоний эскириш',
                depreciationConstructiveElements: 'Конструктив элементларнинг жисмоний эскириши (%)',
                photosToSubmit: 'Бино расмларини юкланг',
                auxiliaryBuilding: 'Ёрдамчи бино',
                attachedTo: 'Қайси бинога бириктирилган',
                description: 'Фикри',
                notExist: 'Бузилган',
                notEvaluated: 'Бахоланмайди',
                usefulArea: 'Бино фойдали майдони (м2)',
            },
            validation: {
                buildingType: 'Илтимос бино турини танланг',
                name: 'Илтимос бино номини киритинг',
                floors: 'Илтимос бино қаватлари сонини киритинг',
                area: 'Илтимос бино қурилиш ости майдонини киритинг',
                height: 'Илтимос бино умумий баландлигини киритинг',
                volume: 'Илтимос бино хажмини киритинг',
                earthquakePoint: 'Илтимос зилзилага бардошлилик коэфициентини танланг',
                businessCoefficient: 'Илтимос тадбиркорлик коэфициентини танланг',
                depreciationPercent: 'Илтимос конструктив элементларнинг жисмоний эскиришини киритинг',
                customField: 'Илтимос {0}ни киритинг',
                customFieldSelect: 'Илтимос {0}ни танланг',
                attachBuilding: 'Илтимос қайси бинога бириктирилганини кўрсатинг',
                cadastreBalance: 'Илтимос кадастр ёки баланс қийматини киритинг',
                heightInner: 'Илтимос бино ички баландлигини киритинг'
            },
            comparison: {
                title: 'Кўчмас мулк биноси - Қиёсий ёндашув',
                titleInner: 'Таккослаш элементлари'
            },
            comparisonIncome: {
                title: 'Кўчмас мулк биноси - Даромад ёндашув'
            },
            regressionModel: {
                title: 'Кўчмас мулк биноси - Регрессион модел'
            }
        },
        payment: {
            list: 'Тўловлар',
            add: 'Тўлов қўшиш',
            edit: 'Тўловни ўзгартириш',
            delete: 'Тўловни ўчириш'
        },
        report: {
            title: 'Ҳисоботлар',
            usersTitle: 'Ҳисобот Ходимлар',
            clientsTitle: 'Ҳисобот Мижозлар',
            date: {
                startDate: 'Сана (дан)',
                endDate: 'Сана (гача)'
            },
            category: {
                appraisers: {
                    code: 'Баҳ',
                    label: 'Авто ва Асбоб-ускуналар'
                },
                appraisersBuilding: {
                    code: 'Баҳ',
                    label: 'Кўчмас мулк'
                },
                agents: {
                    code: 'Аге',
                    label: 'Авто ва Асбоб-ускуналар'
                },
                agentsBuilding: {
                    code: 'Аге',
                    label: 'Кўчмас мулк '
                },
                legalAccounting: {
                    code: 'ҲА',
                    label: 'Авто ва Асбоб-ускуналар'
                },
                legalAccountingBuilding: {
                    code: 'ҲК',
                    label: 'Кўчмас мулк '
                },
                legalAssetReport: {
                    code: 'ҲА',
                    label: 'Аралаш Мол-мулклар'
                },
                appraisersChart: {
                    code: 'БД',
                    label: 'Умумий Диограмма'
                },
                agentChart: {
                    code: 'Аге',
                    label: 'Агент Диограмма'
                },
            },
            field: {
                agents: 'Агентлар',
                bankName: 'Банк',
                mibDepartment: 'МИБ бўлими',
                sspDepartment: 'ССП бўлими',
                fullName: 'Ф.И.Ш',
                mibDebtorName: 'Қарздор номи',
                createdDate: 'Сана',
                region: 'Ҳудуди',
                name: 'Бахолаш объекти номи',
                evaluationPurpose: 'Бахолаш мақсади',
                car: 'Автотранспорт',
                building: 'Кўчмас мулк',
                fitment: 'Асосий воситалар',
                payment: 'Тўлов',
                salary: 'Иш ҳақи(сўм)',
                quantity: 'Сони',
                evaluationPrice: 'Бахолаш нархи(сўм)',
                paid: 'Тушган',
                unpaid: 'Тушмаган',
                objectOfBank: 'Банкдан олинган обект',
                objectOfMib: 'МИБдан олинган обект',
                objectOfSSP: 'ССПдан олинган обект',
                objectType: 'Объект тури',
                province: 'Вилоят',
                district: 'Туман',
                ownerClient: 'Мулк эгаси',
                governmentNum: 'Давлат рақам белгиси',
                accountNumber: 'Хисоб фактура раками ва сана',
                paymentDate: 'Тўлов амалга оширилган',
                customsAdministration: 'Божхона бошқармаси',
                trafficAccidents: 'Йўл транспорт',
                organization: 'Мурожат қилувчи шахс',
                spentTime: 'Бахолашга сарфланган вакт',
                objectNumber: 'Бахолаш объект номери',
                showReport: 'Хисоботни курсатиш (e-baholash.uz учун)',
                confirmedDate: 'Тугатилган сана',
                spenedIsHours: 'Сарфланган вакт',
                spenedIsMinut: 'Сарфланган вакт (minut)',
                spenedToTime: 'Ажратилган вакт',
                by: 'Бўйича',
                pays: 'Тўланганлар',
                unPaid: 'Тўланмаганлар',
                paymentStatus: 'Тўлов холати',
                paymentStatusAll: 'Барчаси',
                paymentStatusPaid: 'Тўланганлар',
                paymentStatusUnPaid: 'Тўланмаганлар',
                paymentStatusSalary: 'Иш ҳақи холати',
                online: 'E-Baxolash сайти',
                inside: 'Узимизда',
                android: 'Android',
                api_mib: 'API_MIB',
                salePropertyStatus: 'Сотувдаги мулк холати',
                salePropertyStatusNONE: 'Кўрилмаганлар',
                salePropertyStatusSOLD: 'Сотилганлар',
                salePropertyStatusUnPaid: 'Сотилмаганлар',
                showConclusion: 'Хулосани кўрсатиш (e-baholash.uz учун)',
            }
        },
        config: {
            title: 'Кўчмас мулк Созлаш',
            autoConfig: 'Авто Созлаш',
            permission: 'Рухсатлар Созлаш',
            rentalRates: 'Ижара тўлови ставкалари',
            reEvaluate: {
                title: 'Қайта баҳолаш',
                name: 'Гуруҳ номи',
                index: 'Индекс',
                byProvinces: 'Минтақалар гуруҳлари',
                productionAndNonProduction: 'Ишлаб чиқариш ва ноишлаб чиқариш бинолари (10000-10018)',
                constructions: 'Иншоотлар (20000-20382)',
                transfer_devices: 'Узатиш қурилмалари',
                machinery_and_equipment: 'Машиналар ва ускуналар (40000-49303)',
                vehicles: 'Транспорт воситалари  (50000-50709)',
                year: 'Йил'
            },
            contractRegion: 'Асосий шартномалар',
            contractAmount: 'Контракт суммаси',
            currency: 'Валюта қурслари',
            populationIncome: {
                title: 'Аҳоли ўртача даромади',
                titleList: 'Аҳоли ўртача даромадлари руйхати',
                edit: {
                    title: 'Аҳоли ўртача даромади'
                }
            },
            product: {
                title: 'Маҳсулот Созлаш',
            },
            productCategory: {
                title: 'Маҳсулот категорияси',
                titleList: 'Маҳсулот категорияси руйхати',
                edit: {
                    title: 'Маҳсулот категорияси'
                }
            },
            products: {
                title: 'Махсулотлар',
                productCategory: {
                    title: 'Тармоқ (Махсулот категорияси)',
                    titleList: 'Тармоқлар(Махсулот категорияси) руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                productSubCategory: {
                    title: 'Суб категорияси',
                    titleList: 'Суб категорияси руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                productManufacture: {
                    title: 'Марка',
                    titleList: 'Махсулот маркаси руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                productModel: {
                    title: 'Модел',
                    titleList: 'Модели руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                macroeconomicIndicators: {
                    title: 'Макроиқтисодий кўрсаткичлар',
                    titleList: 'Макроиқтисодий кўрсаткичлар руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                marketAnalysis: {
                    title: 'Бозор Таҳлили',
                    titleList: 'Бозор Таҳлили руйхати',
                    edit: {
                        title: 'Махсулот категорияси'
                    }
                },
                customs: 'Божхона божи',
                country: 'Мамлакат',
                measurement: 'Ўлчов бирликлари',
                status: 'Статус (Фаол/Ўчирилган)'
            },
            tender: 'Тендер суммаси Созлаш',
            companiesTariff: 'Компаниялар тарифлари',
            appraiserSalary: {
                title: "Бахоловчилар иш ҳақи Созлаш",
                titleList: 'Бахоловчилар иш ҳақи руйхати',
                titleAdd: "Бахоловчилар иш ҳақини қўшиш",
                titleEdit: 'Бахоловчилар иш ҳақини ўзгартириш',
                agents: 'Агентлар',
                appraiser: 'Бахоловчи',
                salary: 'Иш ҳақи(сўм)',
                edit: {
                    title: 'Маҳсулот категорияси'
                }
            },
            gasDevicePrice: {
                title: "Газ ускунаси ҳақи созлаш",
                titleList: 'Газ ускунаси ҳақи руйхати',
                titleAdd: "Газ ускунаси ҳақини қўшиш"
            },
            yearIndex: {
                title: "Йил бўйича индекслар",
                titleList: 'Йил бўйича индекслар руйхати',
                titleAdd: "Йил бўйича индекслар қўшиш"
            },
            monthIndex: {
                title: "Ой бўйича индекслар",
                titleList: 'Ой бўйича индекслар руйхати',
                titleAdd: "Ой бўйича индекслар қўшиш"
            },
            expert2: {
                title: 'Созлаш - Эксперт2'
            },
            syncDbHistory: 'Synchronization DB Histories',
            evaluationAmount: 'Бахолаш қийматларни узгартириш'
        },
        messages: {
            company: {
                success: 'Компания профайли муваффақиятли сақланди',
                error: 'Компания профайлини сақлашда хатолик юз берди',
            },
            list: {
                empty: 'Маълумот мавжуд эмас'
            },
            combo: {
                empty: 'Маълумот топилмади'
            },
            common: {
                error: 'Хато',
                errorOccurred: 'Хатолик юз берди',
                success: '',
                warning: 'Огоҳлантириш',
                saved: 'Сақланди',
                requiredField: 'Илтимос, қиймат киритинг',
                delete: {
                    confirm: 'Вы действительно хотите удалить этот {0}?',
                },
                reallyWant: 'Сиз хакикатдан бу амалиётни амалга оширасизми {0}?',
                removeFileDone: 'Файл муваффақиятли ўчирилди!',
                deleteConfirm: 'Сиз ҳақиқатдан ўчирмоқчимисиз?',
                deleteSuccess: 'Муваффақиятли ўчирилди',
                deleteError: 'Ўчиришда хатолик юз берди'
            },
            realEstate: {
                success: 'Кўчмас мулк муваффақиятли сақланди',
                error: 'Кўчмас мулкни сақлашда хатолик юз берди',
                statusSuccess: 'Кўчмас мулк статуси муваффақиятли ўзгартирилди',
                statusWarning: 'Кўчмас мулк статусини ўзгартиришга сизда рухсат йўқ',
                statusError: 'Кўчмас мулк статусини ўзгартиришда хатолик юз берди',
                showReportSuccess: 'Кўчмас мулк ҳисоботини e-baholash.uz да кўришга рухсат берилди!',
                showCancelReportSuccess: 'Кўчмас мулк ҳисоботини e-baholash.uz да кўришга рухсат бекор қилинди!',
                showReportError: 'Кўчмас мулк ҳисоботини e-baholash.uz да кўришга рухсат беришда хатолик юз берди',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу кўчмас мулкни ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Кўчмас мулк муваффақиятли ўчирилди',
                deleteError: 'Кўчмас мулкни ўчиришда хатолик юз берди',
                reportWarning: 'Бу хисобот тўғрилигига ишончингиз комилми?',
                appraiserReportSignEsp: 'Сиз ишончингиз комил булса хисоботга ЭЦП қуйишингиз зарур! Қўйиш учун "Тасдиқлаш" кнопкаси босинг!',
                appraiserEspSuccess: 'Ҳисоботга ЭЦП қўйиш муваффақиятли бажарилди',
                appraiserEspSuccessInfo: 'Сиз асосий менюга қайтиш учун "Тасдиқлаш" кнопкаси босинг!',
                employmentCoefficientField: {
                    deleteConfirm: 'Сиз ҳақиқатдан ҳам бу маълумотни ўчириб ташламоқчимисиз?',
                    deleteSuccess: 'Маълумотни муваффақиятли ўчирилди',
                    deleteError: 'Маълумотни ўчиришда хатолик юз берди'
                }
            },
            auto: {
                success: 'Автотранспорт муваффақиятли сақланди',
                statusSuccess: 'Автотранспорт муваффақиятли ўзгартирилди',
                statusError: 'Автотранспортни ўзгартиришда хатолик юз берди',
                statusWarning: 'Автотранспорт статусини ўзгартиришга сизда рухсат йўқ',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу Автотранспортни ўчирмоқчимисиз?',
                deleteSuccess: 'Автотранспорт муваффақиятли ўчирилди',
                deleteError: 'Автотранспортни ўчиришда хатолик юз берди',

            },
            fitment: {
                success: 'Асосий восита муваффақиятли сақланди',
                statusSuccess: 'Асосий восита муваффақиятли ўзгартирилди',
                statusError: 'Асосий воситани ўзгартиришда хатолик юз берди',
                statusWarning: 'Асосий восита статусини ўзгартиришга сизда рухсат йўқ',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу Асосий воситани ўчирмоқчимисиз?',
                deleteSuccess: 'Асосий восита муваффақиятли ўчирилди',
                deleteError: 'Асосий воситани ўчиришда хатолик юз берди',

            },
            building: {
                success: 'Кўчмас мулк биноси муваффақиятли сақланди',
                error: 'Кўчмас мулк биносини сақлашда хатолик мавжуд',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу бинони ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Бино муваффақиятли ўчирилди',
                deleteError: 'Бинони ўчиришда хатолик юз берди'
            },
            map: {
                success: 'Худуд муваффақиятли сақланди',
                error: 'Худудни сақлашда хатолик юз берди',
                warning: {
                    title: 'Огоҳлантириш',
                    text: 'Кучмас мулк топилмади!'
                }
            },
            reEvaluation: {
                success: 'Мол-мулк муваффақиятли сақланди',
                error: 'Мол-мулкни сақлашда хатолик юз берди',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу мол-мулкни ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Мол-мулк муваффақиятли ўчирилди',
                deleteError: 'Мол-мулкни ўчиришда хатолик юз берди'
            },
            uzCard: {
                cancelCardTransConfirm: 'Сиз ҳақиқатдан ҳам бу трансакцияни бекор қилмоқчимисиз? Эслатма: Бекор қилишда ушбу тўлов сўммаси орқага қайтиб кетади!'
            },
            regression: {
                analogMsg: 'Аналоглар сони кам.Қушимча аналог киритинг!'
            },
            fixedExpense: {
                success: 'Доимий харажат муваффақиятли сақланди',
                error: 'Доимий харажатни сақлашда хатолик юз берди',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу мол-мулкни ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Доимий харажат муваффақиятли ўчирилди',
                deleteError: 'Доимий харажатни ўчиришда хатолик юз берди'
            },
            ipotekaPaymentTransaction: {
                success: 'Тулов муваффақиятли сақланди',
                error: 'Тулов сақлашда хатолик юз берди',
                listError: 'Тулов руйхатида хатолик юз берди',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу Туловни ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Тулов муваффақиятли ўчирилди',
                deleteError: 'Туловни ўчиришда хатолик юз берди',
                timeUp: 'Вакт тугади'
            },
            cadastreHistorical: {
                updateSuccess: 'Кадастр маълумоти муваффақиятли сақланди',
            },
            companyTariff: {
                success: 'Компаниялар тарифи муваффақиятли сақланди',
                error: 'Компаниялар тарифини сақлашда хатолик юз берди',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам бу компаниялар тарифини ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Компаниялар тарифи муваффақиятли ўчирилди',
                deleteError: 'Компаниялар тарифини ўчиришда хатолик юз берди'
            },
            expert2: {
                statusSuccess: 'Эксперт2 муваффақиятли сақланди',
                error: 'Эксперт2 сақлашда хатолик юз берди',
                validate: 'Саклашни амалга оширинг!',
                statusError: 'Эксперт2 статусини ўзгартиришда хатолик юз берди',
                deleteConfirm: 'Сиз ҳақиқатдан ҳам ушбу Эксперт2ни ўчирмоқчимисиз?',
                deleteSuccess: 'Эксперт2 муваффақиятли ўчирилди',
                deleteError: 'Эксперт2 ўчиришда хатолик юз берди'
            },
            director: {
                success: 'Директор муваффақиятли сақланди',
                error: 'Директорни сақлашда хатолик юз берди'
            },
            client: {
                success: 'Мижоз муаффақиятли сақланди',
                fail: 'Бу мижоз системага олдин қўшилган!',
                notFound: 'Мижоз аниқланмади!',
                error: 'Хатолик юз берди!',
                searchSuccess: 'Мижоз топилди!'
            }
        },
        auto: {
            label: 'Автотранспорт',
            taxes: 'Солиқлар',
            taxesAdd: 'Солиқлар қўшиш',
            customsRate: 'Божхона ставкаси',
            roadCost: 'Йўл харажатлари',
            vat: 'QQS',
            expensesForCustomsClearance: 'Божхона хужжатларини расмийлаштириш харажатлари',
            autoDocs: 'Автотранспортни бахолаш учун тақдим қилинадиган хужжатлар',
            exciseTax: 'Акциз солиқ',
            profitTaxRate: 'Фойда солиги ставкаси',
            rentRate: 'Рентабиллик курсаткичи',
            discountLimit: 'Чегирма учун лимит',
            exciseTaxForCountry: 'Мамлакат учун акциз солиғи',
            countryAdd: 'Мамлакат қўшиш',
            coefficientForDilapidation: 'Улуш вазни',
            addCoefficientForDilapidation: 'Улуш вазни қўшиш',
            autoToEvaluate: 'Баҳоланадиган автотранспортларни киритинг',
            addAuto: 'Автотранспорт қўшиш',
            editAuto: 'Автотранспорт ўзгартириш',
            name: 'Автотранспорт номи',
            selectAuto: 'Автотранспортни танланг',
            deviceType: 'ТВ.тури',
            madeYear: 'Машина чиққан йили',
            governmentNum: 'Машина давлат рақами',
            overpassKm: 'Машинанинг босиб ўтган йўли (км)',
            engineNum: 'Машина двигател рақами',
            bodyNum: 'Машина кузов рақами',
            shasseNum: 'Машина шассе рақами',
            fullWeight: "Машина тўла вазни (кг)",
            autoColor: 'Машина ранги',
            additionalConveniences: 'Хариддан кейинги харажатлар',
            highWeight: 'Машина юксиз вазни (кг)',
            technicalConditionOfCar: 'Машина техник холати',
            dilapidationValueByExpert: 'Эксперт йўли билан эскиришни аниқлааш',
            texPassportNum: 'Машина техпаспорт номери',
            adress: 'Автотранспорт воситасининг техпаспортда кўрсатилган манзили',
            electricalComponents: 'Электр кисмлари',
            tires: 'Шиналари',
            hasNo: 'Бор/Йўқ',
            steeringMechanisms: 'Рул механизмлар',
            engine: 'Двигатель',
            transmissionBox: 'Каробка передачи',
            saloonParts: 'Салон кисмлари',
            technicalConditionReport: 'Техник холати',
            photos: 'Автотранспорт расмлари',
            texPassport: 'Автотранспорт техпаспорти',
            title: 'Автотранспорт маълумотларини киритинг',
            titleAct: 'Автотранспорт маълумотлари',
            success: 'Автотранспорт муваффақиятли баҳоланди!',
            autoGasDevice: 'Газ ускунаси',
            autoGasDeviceName: 'Номи',
            autoGasDevicePrice: 'Нархи',
            autoGasDeviceDilapidation: 'Эскириши',
            autoGasDeviceSource: 'Газ ускунаси сайти URL',
            comparative: 'Қиёсий ёндошув қийматини аниқлаш',
            comparativeLbl: 'Қиёсий ёндошув',
            autoCalculationLabel: 'Автотранспорт баҳолаш ҳисоб-китоби',
            autoCorrectionTypeLabel: 'Харажат ва қиёсий ёндошув усулларни мувофиклаштириш',
            deleteConfirm: 'Сиз ҳақиқатдан ҳам бу автотранспортни ўчириб ташламоқчимисиз?',
            deleteSuccess: 'Автотранспорт муваффақиятли ўчирилди',
            deleteError: 'Автотранспортни ўчиришда хатолик юз берди',
            fuelType: 'Ёқилғи тури',
            list: 'Автотранспорт воситалари рўйхати',
            approachName: 'Ёндашувлар',
            approach: {
                expense: 'Харажат',
                income: 'Даромад',
                comparative: 'Қиёсий',
                regression: 'Регрессион'
            },
            autoLoses: {
                label: 'Етказилган зарар',
                list: 'Автолар рўйхати'
            },
            isFixByIndexLabel: 'Киёсий ёндашув индекс буйича тузатиш бериш',
            autoManufacture: {
                label: 'Авто брендлар',
                list: 'Автотранспорт ишлаб чиқарувчилар',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                manufacture: 'Ишлаб чиқарувчи ташкилот номи',
                error: 'Ишлаб чиқарувчи ташкилот номи киритинг!'
            },
            carCategory: {
                label: 'Автотранспортлар категорияси',
                list: 'Автотранспорт категорияларининг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                category: 'Автотранспорт категорияси',
                error: 'Автотранспорт категориясини киритинг!'
            },
            autoType: {
                label: 'Автотранспортлар турлари',
                list: 'Автотранспорт турларининг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                type: 'Автотранспорт тури',
                error: 'Автотранспорт турини киритинг!',
                autoName: 'Автотранспорт номи',
                model: 'Машина модели',
                fuelType: 'Автотранспорт ёнилиги тури',
                createDate: 'Яратилган сана',
                country: 'Мамлакат',
                stopProduction: 'Бахолаш тури',
                typeOfCar: 'Авто тури',
                carPositions: 'Авто позиция',
                gearBoxType: 'Коробка передач',
                horsePower: 'Машина от кучи',
                engineCapacity: 'Двигател хажми',
                fullWeight: 'Машина тўла вазни (кг)',
                trackTypes: 'Юк транспорт тури',
                seatNumber: 'Ўриндиқлар сони',
                checkTrackedTire: 'Занжирли (Гусеницали)',
                checkCustomsTax: 'Божхона божи ва харажатларини ҳисобга олиш.',
                checkStopProduction: 'Ишлаб чиқаришдан олиб ташланган',
                rentType: 'Машина рентабиллиги',
                rentValue: 'Рентабиллик коэффициенти',
                categorization: 'Туркумлилиги',
                carryingCapacity: 'Юк оғирлиги (кг)',
                axletree: 'Ғилдирак ўқи'
            },
            autoPrice: {
                currency: 'Валюта',
                price: 'Автотранспорт нархи',
                pricingDate: 'Нарх ўрнатилган сана',
                source: 'Олинган манба'
            },
            carCoincidental: {
                label: 'Турдош автотранспортлар',
                list: 'Турдош автотранспортларнинг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                coincidental: 'Турдош автотранспорт',
                autoTypeFullName: 'Автотранспорт номи',
                carCoincidentalFullName: 'Турдош автотранспорт номи',
                createDate: 'Киритилган сана',
                createUserName: 'Томонидан яратилган',
                error: 'Турдош автотранспортни киритинг!'
            },
            autoTexPassport: {
                label: 'Техпаспорти маълумотлари',
                list: 'Техпаспорти маълумотлари рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                texPassport: 'Техпаспорти',
                texPassportNumber: 'Автотранспорт техпаспорт номери',
                governmentNum: 'Автотранспорт давлат рақам белгиси',
                autoName: 'Автотранспорт номи',
                createDate: 'Киритилган сана',
                updateDate: 'Ўзгартирилган сана',
                createUserName: 'Томонидан киритилган',
                updateUserName: 'Томонидан ўзгартирилган',
                ownerName: 'Автотранспорт эгаси номи',
                engineNum: 'Автотранспорт двигател рақами',
                bodyNum: 'Автотранспорт кузов рақами',
                shasseNum: 'Автотранспорт шассе рақами',
                fullWeight: 'Автотранспорт тўла вазни (кг)',
                madeYear: 'Автотранспорт чиққан йили',
                autoColor: 'Автотранспорт ранги',
                highWeight: 'Автотранспорт юксиз вазни (кг)',
                fuelType: 'Автотранспорт ёқилғи тури',
                address: 'Манзили',
                identificationNumber: 'Автотранспорт эгаси ИНН рақам',
                pinflNumber: 'Автотранспорт эгаси ЖШШИР (ПИНФЛ) рақам',
                innOrPinflNumber: 'Автотранспорт эгаси (ПИНФЛ/ИНН) рақам',
                texPasDataStatus: 'Статус',
                birthDate: 'Автотранспорт эгаси тўғилган санаси',
                validation: {
                    minText: 'Ушбу майдон камида ',
                    minValid: ' та белгидан иборат бўлиш керак!',
                    maxText: 'Ушбу майдон ',
                    maxValid: ' та белгидан иборат бўлиш керак!',
                    birthDate: 'Мижоз тўғилган санасини керак!',
                    pinflNumber: 'Жисмоний шаҳснинг шаҳсий идентификация рақамини киритинг!',
                    identificationNumber: 'ИННни киритинг!',
                    texPassportNumber: 'Автотранспорт техпаспорт номерини киритинг!',
                    governmentNum: 'Автотранспорт давлат рақам белгисини киритинг!',
                    autoName: 'Автотранспорт номини киритинг!',
                    ownerName: 'Автотранспорт эгаси номини киритинг!',
                    engineNum: 'Автотранспорт двигател рақамини киритинг!',
                    bodyNum: 'Автотранспорт кузов рақамини киритинг!',
                    shasseNum: 'Автотранспорт шассе рақамини киритинг!',
                    fullWeight: 'Автотранспорт тўла вазнини киритинг!',
                    madeYear: 'Автотранспорт чиққан йилини киритинг!',
                    autoColor: 'Автотранспорт рангини киритинг!',
                    highWeight: 'Автотранспорт юксиз вазнини киритинг!',
                    fuelType: 'Автотранспорт ёқилғи турини киритинг!',
                    address: 'Манзилини киритинг!'
                }
            },
            newAutoPriceList: {
                label: 'Янги автотранспорт нархлари',
                list: 'Янги автотранспорт нархларнинг рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                newAutoPrice: 'Янги автотранспорт нархи',
                autoType: 'Автотранспорт',
                autoManufacture: 'Ишлаб чиқарувчи',
                createDate: 'Киритилган сана',
                pricingDate: 'Нарх ўрнатилган сана',
                createUserName: 'Томонидан яратилган',
                priceListFile: 'Прайст листни юкланг',
                error: 'Автотранспорт нархини киритинг!'
            },
            autoParts: {
                label: 'Авто эхтиёт кисмлар',
                list: 'Авто эхтиёт кисмлар рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                name: 'Эхтиёт кисм номи',
                measurement: 'Ўлчов бирликлари',
                createdDate: 'Яратилган сана',
                createdBy: 'Томонидан яратилган',
                error: 'Хато',
            },
            smallAutoPart: {
                label: 'Кичик эхтиёт кисмлар',
                list: 'Кичик эхтиёт кисмлар рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                error: 'Хато',
                price: 'Нархи',
                name: 'Кичик эхтиёт кисм номи',
                measurement: 'Ўлчов бирликлари',
                createdDate: 'Яратилган сана',
                createdBy: 'Томонидан яратилган'
            },
            autoPartsNormHours: {
                label: 'Автотранспорт қисмларини таьмир муддати нормалари',
                list: 'Автотранспорт қисмларини таьмир муддати нормалари рўйхати',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                error: 'Хато',
                price: 'Автотранспорт қисмларининг нархи',
                upgrade: 'Автотранспорт қисмларини янгилаш муддати нормаси',
                repair: 'Автотранспорт қисмларини таьмир муддати нормаси',
                source: 'Автотранспорт қисмларини нархи манбаси',
                autoPart: 'Автотранспорт қисмларини',
                autoType: 'Автотранспорт',
                createdDate: 'Яратилган сана',
                createdBy: 'Томонидан яратилган'
            },
            plus: {
                list: 'Авто Баҳолаш Плюс',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                autoInformationVisible: 'Автотранспорт маълумотлари',

            }
        },
        accounting: {
            title: 'Бухгалтерия',
            titleLegalAccounting: 'Ҳуқуқий ҳисобот',
            account: {
                category: {
                    accountBook: {
                        code: 'A',
                        label: 'Автотранспорт ва Асбоб-ускуналар'
                    },
                    accountBuildingBook: {
                        code: 'К',
                        label: 'Кўчмас мулк'
                    },
                    accountAsset: {
                        code: 'А',
                        label: 'Аралаш Мол-мулклар'
                    }
                },
                name: 'Номи',
                accountBook: 'Бухгалтерия хисоби китоб',
                organization: 'Ташкилот',
                province: 'Вилоят',
                district: 'Туман',
                city: 'Шаҳар',
                date: 'Санаси',
                number: 'Раками',
                executiveJob: "Ижро иши",
                bankMFO: "МФО",
                accountNumber: "Ҳисоб-рақами",
                identificationNumber: "ИНН",
                pinflNumber: 'Жисмоний шаҳснинг шаҳсий идентификация рақами (ЖШШИР 14 рақам)',
                contract: 'Шартнома',
                order: 'Буюртма',
                report: 'Ҳисобот',
                feeService: 'Хизмат хакки (сўм)',
                invoice: 'Счёт фактура',
                jobName: 'Бажарилган иш номи',
                priceWithoutQQS: 'ҚҚСсиз нархи (сўм)',
                qqs: 'ҚҚС',
                totalAmountQQS: 'Жами суммаси ҚҚС билан (сўм)',
                qqsRate: 'Ставкаси',
                qqsAmount: 'Суммаси, (сўм)',
                requirement: 'Талабнома',
                totalAmount: 'Жами суммаси',
                including: 'Шу жумладан',
                principalDebt: "Aсосий қарз",
                priceFine: "Жарима",
                pricePenny: "Пеня",
                paymentDocument: "Тўлов ҳужжати",
                vatPayment: "НДС тўловлар",
                vatEnterPayment: "НДС киритиш",
                debtBalance: "Қолдиқ қарздорлик",
                creditor: "Кредитор",
                amountPrice: "Сўммаси",
                debtor: "Дебитор",
                registrationPayDoc: "Тўлов ҳужжатини рўйхатга олиш",
                paymentSource: "Тўлов тури",
                registrationPayDocList: "Тўлов ҳужжатини рўйхати",
                paymentDelayed: "Тўлов кечиктирилган",
                numberDays: "Кунлар сони",
                calculated: "Ҳисобланган",
                lostProfitOrDamage: "Бой берилган фойда ёки зарар",
                saleProperty: "Сотувдаги мулк",
                propertyType: "Мулк тури",
                numberLot: "Лот рақами",
                saleDate: "Савдо бўладиган кун",
                salesDateAndPrice: "Сотилган сана ва нархи",
                sellingPrice: "Сотилган нарх",
                reportDateTotalNumberOfDays: "Ҳисобот санасигача жами кунлар сони",
                paymentOfLastDate: "Тўловнинг охирги санаси",
                accordingContract: "Шартномага мувофиқ",
                decision1154: "12.05.1996 даги ПФ-1154 га мувофиқ",
                numberDaysLastDatePayment: "Тўлов сўнгги санасигача кунлар сони",
                numberBorrowerDays: "Дебитор муддати ўтган кунлар сони",
                residualBorrowingPennyFineLossNotIncluded: "Қолдиқ қарздорлик пеня, жарима, зарар киритилмаган",
                residualBorrowingPennyFineLossAlongWith: "Жами қарздорлик пеня, жарима, зарар билан бирга",
                physical: "Жисмоний шахс",
                legal: "Юридик шахс",
                fullName: "Ф.И.О (Ташкилот номи)",
                passportNumber: "Паспорт серия раками (Манзили юридик)",
                source: 'Манба',
                esp: "E-imzo",
                property: "Мулк",
                additionalCalculatedMoney: "Кушимча хисобланган маблағ (Жамият)",
                societyFunds: "Асосий маблағи (Жамият)",
                districtAndCity: 'Туман ва Шаҳар',
                createdUserName: 'Ким томонидан яратилган',
                objectType: 'Объект тури',

            },
            accountMessages: {
                success: 'Муваффақиятли сақланди',
                error: 'Сақлашда хатолик юз берди',
                fillAllFields: 'Майдонларни тулик киритинг',
            },
        },
        common: {
            users: 'Ходимлар',
            currency: 'Валюта',
            startDate: 'Дан',
            endDate: 'Гача',
            code: 'Код',
            comment: 'Изоҳ',
            name: 'Номи',
            fullName: 'Полное наименование',
            shortName: 'Краткое наименование',
            add: 'Қўшиш',
            group: 'Гуруҳ',
            nameRU: 'Номи (RU)',
            qty: 'Миқдори',
            inn: 'ИНН',
            inps: 'ИНПС',
            status: 'Статус',
            draft: 'Қоралама',
            annul: 'Бекор қилиш',
            search: 'Қидириш',
            netAmount: 'Чистая сумма',
            total: 'Всего',
            login: 'Логин',
            password: 'Парол',
            smsCode: 'Смс код',
            transferMoney: 'Утгазиш',
            active: 'Актив',
            deactive: 'Ноактив',
            date: 'Сана',
            createdDate: 'Яратилган сана',
            updateDate: 'Ўзгартирилган сана',
            createdBy: 'Создано',
            evlPrice: 'Бахоланган қиймати',
            paymentWithUzCard: 'Тулов UzCard',
            createType: {
                ourselves: 'Ўзимизда',
                online: 'E-Baxolash сайти',
                android: 'Android',
                apiMib: 'API MIB',
                api_bank: 'API BANK',
                api_backend: 'API BACKEND',
                api_online: 'API ONLINE',
                api_exarid: 'API E-XARID',
                expert2: 'Эксперт 2'
            },
            evlStatus: {
                notReady: 'Тайёр эмас',
                pending: 'Хали кўрилмади',
                notFullyEvaluated: 'Жараёнда',
                confirmed: 'Тасдиқланган',
                rejected: 'Бекор қилинган',
                assignedToEvaluator: 'Бахоловчига бириктирилди',
                evaluated: 'Бахоланган',
                sentToComplement: 'Тўлдирувчига бириктирилди'
            }
        },
        map: {
            title: 'Карта',
            category: {
                drawPolygon: {
                    code: '',
                    label: 'Кўчмас мулк худудларини чизиш'
                },
                organizationMap: {
                    code: '',
                    label: 'Кўчмас мулк жойлашган урни'
                }
            },
            realEstateType: 'Кўчмас мул тури',
            accommodation: 'Турар жой',
            multiStoriedAccommodation: 'Кўп каватли турар жой',
            landAreaAccommodation: 'Ер майдони турар',
            noResidentialLand: 'Ер майдони но турар',
            shop: 'Дўкон',
            restaurantCafe: 'Ресторан кафе',
            office: 'Офис',
            warehouse: 'Омборхона',
            leisureDatabases: 'Дамолиш базалари',
            buildingsProduction: 'Ишлаб чикаришга мўлжаланган бинолар',
            notProductionBuildings: 'Ишлаб чикаришга мўлжаланмаган бинолар',
            otherBuildings: 'Бошкалар'
        },
        eAppraisal: {
            title: 'Буюртмалар',
            objectType: {
                realEstate: {
                    code: 'М',
                    label: 'Кўчмас-мулк (Бахолаш плюс)'
                },
                auto: {
                    code: 'A',
                    label: 'Авто (Бахолаш плюс)'
                },
                fitment: {
                    code: 'Б',
                    label: 'Асосий восита (Бахолаш плюс)'
                },
                asset: {
                    code: 'A',
                    label: 'Аралаш мол-мулк (Бахолаш плюс)'
                },
                autonc: {
                    code: 'ANC',
                    label: 'Онлайн авто NC'
                },
                order: {
                    code: 'ОБ',
                    label: 'Онлайн буюртма'
                },
                expert2: {
                    realEstate: {
                        code: 'E2',
                        label: 'Кўчмас-мулк (Эксперт2)'
                    },
                    asset: {
                        code: 'E2',
                        label: 'Аралаш мол-мулк (Эксперт2)'
                    },
                    fitment: {
                        code: 'E2Б',
                        label: 'Асосий восита (Эксперт2)'
                    },
                    auto: {
                        code: 'E2A',
                        label: 'Авто (Эксперт2)'
                    },
                    losses: {
                        code: 'EE',
                        label: 'Онлайн эксперт2 Етказилган зарар'
                    }
                }
            }
        },
        asset: {
            name: 'Мол-мулклар',
            title: 'Аралаш мулкларни баҳолаш рўйхати',
            assetAdd: 'Аралаш мол-мулк қўшиш',
            assetEdit: 'Аралаш мол-мулкни ўзгартириш',
            assetView: 'Аралаш мол-мулкни кўриш',
            assetDocs: 'Аралаш мол-мулкни бахолаш учун тақдим қилинадиган хужжатлар',
            passport: 'Пасспорт нусхаси',
            document: 'Ташкилот рахбарининг мурожат хати',
            actOfSale: 'Акт',
            decision: 'Карор',
            playlist: 'Ижро варакаси',
            assetToEvaluate: 'Баҳоланадиган Аралаш мол-мулкни киритинг',
            titleAddEdit: 'Аралаш мол-мулкни бахолаш',
            titleAddEditNotorious: 'Аралаш мол-мулкни бахолаш (Нотурар жой)',
            titleAddEditResidential: 'Аралаш мол-мулкни бахолаш (Турар жой)',
            deleteConfirm: 'Сиз ҳақиқатдан ҳам бу аралаш мол-мулкни ўчириб ташламоқчимисиз?',
            realEstateToEvaluate: 'Баҳоланадиган кўчмас мулкни киритинг',
            statusSuccess: 'Аралаш мол-мулк статуси муваффақиятли ўзгартирилди',
            statusWarning: 'Аралаш мол-мулк статусини ўзгартиришга сизда рухсат йўқ',
            statusError: 'Аралаш мол-мулк статусини ўзгартиришда хатолик юз берди',
            deleteSuccess: 'Аралаш мол-мулк муваффақиятли ўчирилди',
            deleteError: 'Аралаш мол-мулкни ўчиришда хатолик юз берди',
            esp: {
                title: 'Аралаш мол-мулкни ЭЦП орқали имзолаш',
                titleAppraiser: 'Аралаш мол-мулкни бахоловчи ЭЦП орқали имзолаш',
                invoice: 'Хисоб варак фактурага ЭЦП имзо қўйиш (Имзо куйишдан олдин Хисоб варак фактура билан танишиб чикинг)',
                report: 'Хисоботга ЭЦП имзо куйиш (Имзо қўйишдан олдин Хисобот билан танишиб чикинг)',
                reportDownload: 'Илтимос кутинг ҳисобот юкланмокда!',
                contractDownload: 'Илтимос кутинг шартнома юкланмокда!'
            },
            code: 'A',
            plus: {
               code: 'A(+)',
               label: 'Мол-мулклар (плюс)'
            },
            titlePlusList: 'Аралаш мулкларни рўйхати (Баҳолаш плюс)'
        },
        business: {
            name: 'Бизнес',
            title: 'Бизнесни баҳолаш рўйхати',
            add: 'Бизнес қўшиш',
            edit: 'Бизнесни ўзгартириш',
            view: 'Бизнесни кўриш',
            businessDocs: 'Бизнесни бахолаш учун тақдим қилинадиган хужжатлар',
            passport: 'Пасспорт нусхаси',
            document: 'Ташкилот рахбарининг мурожат хати',
            actOfSale: 'Акт',
            decision: 'Карор',
            playlist: 'Ижро варакаси',
            businessToEvaluate: 'Баҳоланадиган бизнесларни киритинг',
            titleAddEdit: 'Бизнесни бахолаш',
            titleAddEditNotorious: 'Бизнесни бахолаш (Нотурар жой)',
            titleAddEditResidential: 'Бизнесни бахолаш (Турар жой)',
            deleteConfirm: 'Сиз ҳақиқатдан ҳам бу бизнес ўчириб ташламоқчимисиз?',
            realEstateToEvaluate: 'Баҳоланадиган кўчмас мулкни киритинг',
            statusSuccess: 'Бизнес статуси муваффақиятли ўзгартирилди',
            statusWarning: 'Бизнес статусини ўзгартиришга сизда рухсат йўқ',
            statusError: 'Бизнес статусини ўзгартиришда хатолик юз берди',
            esp: {
                title: 'Кучмас мулкни ЭЦП орқали имзолаш',
                invoice: 'Хисоб варак фактурага ЭЦП имзо қўйиш (Имзо куйишдан олдин Хисоб варак фактура билан танишиб чикинг)',
                report: 'Хисоботга ЭЦП имзо куйиш (Имзо қўйишдан олдин Хисобот билан танишиб чикинг)',
                reportDownload: 'Илтимос кутинг ҳисобот юкланмокда!',
                contractDownload: 'Илтимос кутинг шартнома юкланмокда!'
            },
            financeResult: {
                success: 'Молиявий натижа муваффақиятли сақланди',
            }
        },
        fitment: {
            label: 'Бошқа мол-мулк',
            list: 'Бошқа мол-мулклар рўйхати',
            name: 'Бошқа мол-мулк номи',
            fitmentDocs: 'Бошқа мол-мулкни бахолаш учун тақдим қилинадиган хужжатлар',
            title: 'Бошқа мол-мулк маълумотларини киритинг',
            titleJewelry: 'Заргарлик буйумлар маълумотларини киритинг',
            fitmentToEvaluate: 'Баҳоланадиган бошқа мол-мулкларни киритинг',
            fitmentAdd: 'Бошқа мол-мулклар қўшиш',
            jewelryAdd: 'Заргарлик буйумлар қўшиш',
            fitmentEdit: 'Бошқа мол-мулкларни ўзгартириш',
            brandName: 'Бошқа мол-мулклар бренди',
            model: 'Бошқа мол-мулклар модели ',
            useWebSite: 'Манба',
            foreign: 'Божхона божини ҳисобга олиш',
            qty: 'Количество',
            um: 'Ўлчов бирлиги',
            price: 'Цена',
            madeYear: 'Ишлаб чиқарилган йили',
            technicalCondition: 'Техник холати',
            madeCountry: 'Ишлаб чиққарилган мамлакат',
            province: 'Вилояти',
            partConditions: 'Умумий холати',
            photos: 'Расмлари',
            texPassport: 'Техпаспорти',
            texPassportNumber: 'Техпаспорт номери',
            aboutTexPassport: 'Техпаспорт тафнифи',
            hallmark: 'Пробаси',
            weigh: 'Огирлиги',
            metalType: 'Заргарлик буюми тури',
            gold: 'Олтин',
            silver: 'Кумуш',
            stoneName: 'Тош номи',
            stonePrice: 'Тош киймати',
            overlayCoefficient: 'Устама коэффициент',
            deleteConfirm: 'Сиз ҳақиқатдан ҳам бу Бошқа мол-мулкни ўчириб ташламоқчимисиз?',
            deleteSuccess: 'Бошқа мол-мулк муваффақиятли ўчирилди',
            deleteError: 'Бошқа мол-мулкни ўчиришда хатолик юз берди',
            dilapidationValue: 'Эскириш',
            jewelery: 'Заргарлик буйумлар',
            fitmentType: 'Бошқа мол-мулк тури',
            address: 'Объект манзили',
            customsDuty: 'Божхона божи',
            esp: {
                title: 'Бошқа мол-мулкни ЭЦП орқали имзолаш',
                titleAppraiser: 'Бошқа мол-мулкни бахоловчи ЭЦП орқали имзолаш',
                invoice: 'Хисоб варак фактурага ЭЦП имзо қўйиш (Имзо куйишдан олдин Хисоб варак фактура билан танишиб чикинг)',
                report: 'Хисоботга ЭЦП имзо куйиш (Имзо қўйишдан олдин Хисобот билан танишиб чикинг)',
                reportDownload: 'Илтимос кутинг ҳисобот юкланмокда!',
                contractDownload: 'Илтимос кутинг шартнома юкланмокда!'
            },
            plus: {
                list: 'Баҳолаш Плюс',
                add: 'Қўшиш',
                edit: 'Ўзгартириш',
                view: 'Кўриш',
                priceListPhoto: 'Прайст лист',
                evaluatorConfirmed: 'Бахоловчи тасдиқлаган',
                directorConfirmed: 'Директор тасдиқлаган',
                information: 'Бошқа мол-мулк маълумотлари',

            }
        },
        settings: {
            otherConfig: 'Бошқа конфигурация',
            evaluationPrices: 'Баҳолаш нархи',
            efunctionTypesYim: 'Фаолия турига караб коффицент'
        },
        reportGeneralDirector: {
            title: 'Хисобот Генералний директор',
            category: {
                reportOfWorkDone: {
                    code: '',
                    label: 'Бажарилган иш ҳақида хисобот'
                },
                expenses: {
                    code: '',
                    label: 'Компания харажатлар',
                    name: 'Харажат номи',
                    paidDate: 'Тўланган сана',
                    companyExpenseType: 'Харажат тури',
                    paymentNumber: 'Тулов топширикнома раками',
                    paymentAmount: 'Ўтказилган сумма',
                    description: 'Изох'
                },
                income: {
                    code: '',
                    label: 'Компания киримлари',
                    name: 'Кирим номи',
                    incomeDate: 'Кирим санаси',
                    incomingNumber: 'Кирим раками',
                    incomeAmount: 'Кирим суммаси',
                    description: 'Изох'
                },
                realTimeWorkDone: {
                    code: '',
                    label: 'Реал вакт бажарилган иш'
                }
            },
            agents: 'Агентлар',
            province: 'Вилоят',
            organizationsOther: 'Бошқа ташкилотлар',
            realEstate: 'Кўчмас мулк',
            autoAndFitment: 'Авто ва Асбоб-ускуналар',
            quantity: 'Сони',
            mibDepartment: 'МИБ',
            sspDepartment: 'ССП',
            customsDepartment: 'БОЖХОНА',
            bankDepartment: 'БАНК',
            autoLossesDepartment: 'ДТП',

        },
        reEvaluation: {
            name: 'Мол-мулкни кайта баҳолаш',
            titleList: 'Мол-мулкларни кайта баҳолаш рўйхати',
            titleAddEdit: 'Мол-мулкларни кайта бахолаш',
            add: {
                title: 'Қайта бахолаш мол-мулк маълумотларини киритинг'
            },
            edit: {
                title: 'Қайта бахолаш мол-мулкни ўзгартириш'
            },
            view: {
                title: 'Қайта бахолаш мол-мулкни куриш',
                eAppraisalTitle: ' E-Баҳолаш: Кўчмас мулк умумий маъмумотлари'
            },
            delete: {
                title: 'Ўчириш'
            },
            field: {
                oldRecoveryDate: 'Дастлабки тикланиш санаси',
                oldRecoveryReportNumber: 'Дастлабки тикланиш хисобот раками',
                organizationName: 'Ташкилот номи',
                orgIdentificationNumber: 'Ташкилот ИНН',
                docsToSubmit: 'Мол-мулкни кайта баҳолаш учун тақдим қилинадиган хужжатлар',
                docDocuments: 'Мурожат хати',
                docApplication: 'Иловалар',
                toReEvaluate: 'Қайта бахоланадиган мол-мулкни киритинг',
                addItem: 'Мол-мулк қушиш',
                calcExcel: 'Ҳисоб-китоб Excel'
            },
            item: {
                field: {
                    name: 'Мол-мулк номи',
                    stockCode: 'Асосий фондларнинг коди',
                    numberOfProperty: 'Мол-мулк сони',
                    propertyNumber: 'Асосий восита раками',
                    oldRecoveryAmount: 'Дастлабки тикланиш киймати',
                    depreciationAmount: 'Эскириш',
                    balanceAcceptedDate: 'Балансга кабул килинган сана',
                    reEvaluateIndex: 'Қайта бахолаш индекси',
                    province: 'Вилоят',
                    residualAmount: 'Қолдиқ қиймат'
                }
            },
            validation: {
                oldRecoveryDate: 'Илтимос дастлабки тикланиш санасини танланг',
                oldRecoveryReportNumber: 'Илтимос дастлабки тикланиш хисобот ракамини киритинг',
                organizationName: 'Илтимос қайта бахолаш утказган ташкилот номини киритинг',
                orgIdentificationNumber: 'Илтимос ташкилот (ИНН)ни киритинг'
            }
        },
        finance: {
            name: 'Finance',
            titleListUzCard: 'Uzcard трансакциялар рўйхати',
            titleListUserBalance: 'Фойдаланувчи баланси рўйхати',
            uzCard: {
                transaction: {
                    code: 'UzC',
                    label: 'Uzcard трансакциялар',
                    status: {
                        wait: 'Кутилмокда',
                        paid: 'Туланган',
                        cancel: 'Бекор килинган',
                        unknown: 'Номаълум',
                    }
                }
            },
            ipoteka: {
                titleListDebit: 'Ipoteka Дебет трансакциялар рўйхати',
                titleListCredit: 'Ipoteka Кредит трансакциялар рўйхати',
                titleListCreditBind: 'Ipoteka Кредит трансакциялар бирлаштириш рўйхати',
                getTransaction: 'Трансакциялар юклаб олиш Ipoteka-Bank',
                getTransactionConfirm: 'Сиз ҳақиқатдан ҳам бу трансакцияни юклаш қилмоқчимисиз?',
                balanceAccounts: 'Хисоб ракамлардаги колдикни куриш',
                balanceAccountsConfirm: 'Сиз ҳақиқатдан ҳам колдикни курмокчимисиз?',
                balanceAccountsList: 'Хисоб ракамлар рўйхати',
                bindToObject: 'Объект бирлаштириш',
                rejectTransaction: 'Трансакцияни кайтариш',
                rejectReason: 'Кайтариш сабаби',
                titleListFixedExpenses: 'Доимий харажатлар рўйхати',
                titleIpotekaPaymentList: 'Ipoteka Тулов трансакциялар рўйхати',
                titleListFixedReadyTransferExpenses: 'Доимий харажатлар учун трансакциялар рўйхати (ойлик, хафтлик)',
                transaction: {
                    code: 'IPO',
                    creditLabel: 'Ipoteka Кредит трансакциялар',
                    debitLabel: 'Ipoteka Дебет трансакциялар',
                    status: {
                        paid: 'Туланган',
                        unknown: 'Номаълум',
                    }
                },
                fixedExpenses: {
                    titleNew: 'Янги Доимий харажат киритиш',
                    titleEdit: 'Доимий харажат ўзгартириш',
                    expenseType: 'Харажат тури',
                    titleExpenseTypeList: 'Харажат тури рўйхати',
                    expenseTypeAdd: 'Янги Харажат тури',
                    expenseTypeEdit: 'Ўзгартириш Харажат тури',
                    fixedExpensePaymentPeriodType: 'Доимий тулов',
                    fixedExpensePaymentDate: 'Доимий тўлов санаси'
                },
                paymentTransaction: {
                    titleNew: 'Янги Тулов киритиш',
                    titleEdit: 'Тулов ўзгартириш',
                    confirmMsg: 'Тулов амалга оширишни хохлайсизми? Тулов амалга оширилган сунг оркага кайтиб булмайди',
                    draftMsg: 'Қоралама (Черновик) килиб куйиш?',
                    creditName: "Кредит Ташкилот номи",
                    creditINN: "Кредит ИНН",
                    creditAccount: "Кредит Хисоб ракам",
                    creditBankName: "Кредит Банк номи",
                    creditMFO: "Кредит МФО",
                    debetName: 'Дебет Ташкилот номи',
                    debetINN: 'Дебет ИНН',
                    debetMFO: 'Дебет МФО',
                    debetAccount: 'Дебет Хисоб ракам',
                },
                field: {
                    debitCredit: 'Дебет/Кредит',
                    debit: 'Дебет',
                    credit: 'Кредит',
                    IID: 'IID',
                    DATE_ENTER: 'DATE_ENTER',
                    DATE_PROV: 'DATE_PROV',
                    DATE_DOC: 'DATE_DOC',
                    NUM_DOC: 'NUM_DOC',
                    ACC_DB: 'ACC_DB',
                    BANK_DB: 'BANK_DB',
                    NAME_DB: 'NAME_DB',
                    ACC_CR: 'ACC_CR',
                    BANK_CR: 'BANK_CR',
                    NAME_CR: 'NAME_CR',
                    SUMMA: 'SUMMA',
                    PURPOSE: 'PURPOSE',
                    INN_DB: 'INN_DB',
                    INN_CR: 'INN_CR',
                    contractNumber: 'Шартнома раками',
                    reminderAfterSharing: 'Колдик',
                    bound: 'Бириктирилган',
                    not_fully_bound: 'Кисман Бириктирилган',
                    spare_money: 'Ортиқча пул',
                    not_bound: 'Бириктирилмаган',
                    wrong_transfer: 'Нотугри утказмалар',
                    fixedExpensesName: 'Доимий харажат номи',
                    payDate: "Тўлов ўтказиладиган сана",
                    payAmount: "Тўлов Суммаси",
                    creditName: "Ташкилот номи",
                    creditINN: "ИНН",
                    creditAccount: "Хисоб ракам",
                    creditBankName: "Банк номи",
                    creditMFO: "МФО",
                    documentNumber: "Номер документа",
                    documentId: "ID документа",
                    transactionId: "ID Трансакция",
                    operationType: "Тип проводки",
                    creditPurpose: " Тўлов максади",
                    codeBudget: "Код Бюджет",
                    nameBudget: "Бюджет номи",
                    accountBudgetIncome: "Доход бюджета аккаунта",
                    innBudget: "Бюджет ИНН",
                }
            },
            paynet: {
                transaction: {
                    code: 'PayN',
                    label: 'Трансакциялар рўйхати'
                }
            },
            field: {
                cardNumber: 'Карта рақами',
                phoneNumber: 'Телефон раками',
                yourMobileNumber: 'Сизнинг Телефон ракамингиз',
                contractNumber: 'Шартнома раками',
                payerName: 'Тўлов қилувчи',
                source: 'Манба',
                amount: 'Тўланган сумма',
                performTime: 'Тўлов Вақти',
                status: 'Статус',
                action: 'Жараён',
                checkedDate: 'Текширилган санаси:',
                target: 'Объект тури',
                date: 'Тўлов сана',
                createDate: 'Яратилган сана',
                beginDate: 'Сана(дан)',
                endDate: 'Сана(гача)',
                search: 'Излаш',
                objectId: 'Объект ID',
                contractAmount: 'Шартнома сумма',
                user: 'Фойдаланувчи'
            },
            action: {
                checkTrans: 'Текшириш',
                cancelTrans: 'Қайтариш'
            },
            userBalance: {
                code: 'UB',
                label: 'Баланслар'
            },
            deposit: {
                titleList: 'Агентлар Депозити',
                code: 'ДР',
                appraiser: {
                    title: 'Ходимлар Депозити',
                    code: 'БД',
                },
                regionalLeader: {
                    title: 'Худудий рахбар Депозити',
                    code: 'ХРД',
                },
                cashTransfer: "Пул ўтказиш",
                cashAmount: "Пул миқдори",
            },
            balance: {
                titleList: 'Ходимлар баланси',
                code: 'ХБ',
                cashTransfer: "Пул ўтказиш",
                cashAmount: "Пул миқдори",
                fullName: 'Ф.И.Ш',
                statusBalance: 'Статус Баланс',
                user: 'Фойдаланувчи',
                date: 'Сана'
            },
            salary: {
                titleList: 'Ходимлар иш ҳақи',
                code: 'ИХ',
                cashTransfer: "Пул ўтказиш",
                cashAmount: "Пул миқдори",
                fullName: 'Ф.И.Ш',
                statusBalance: 'Статус Баланс',
                user: 'Фойдаланувчи',
                date: 'Сана'
            }
        },
        newRealEstate: {
            name: 'Янги кучмас мулк',
            titleList: 'Янги кўчмас мулклар рўйхати',
            titleListNotorious: 'Янги кўчмас мулклар рўйхати (Нотурар жой)',
            titleListResidential: 'Янги кўчмас мулклар рўйхати (Турар жой)',
            report: 'Янги кўчмас мулклар ҳисобот',
            income: {
                title: 'Даромад ёндашув ҳисоб-китоби',
                rentTitle: 'Ижара ҳисоб-китоби',
                valEs: 'Бир йилга бир кв. метр учун энг кам ставка, (Эс)',
                valKk: 'Бинонинг қурилиш тури бўйича коэффициентлар(Кк)',
                valKh: 'Туташиб кетган ҳудуддан фойдаланиш коэффициента(Кҳ)',
                valKt: 'Тижорат мақсадида фойдаланишда қулайлик коэффициента (Кт)',
                valTs: 'Бир йилга бир кв. метр учун ижара тўловининг таянч ставкаси, (Тс)'
            },
            validation: {
                buildingType: 'Илтимос фойдаланиш мақсадини танланг',
                repairCondition: 'Илтимос таъмир холатини танланг',
                wall: 'Илтимос қурилиш турини киритинг',
                constructionCompletion: 'Илтимос қурилиш тугалланганлиги киритинг',
                usefulAreaValid: 'Фойдали майдон хато киритилди!',
                architecturalStyle: 'Архитектуравий услуб (Фасад) киритинг!'
            },
            field: {
                plus: {
                    category: 'Категория & Субкатегория',
                    createdBy: 'Буюртмачи',
                    source: 'Манба',
                    assignedDateToAgent: 'Агентга бириктирилган сана',
                    assignedDateToEvaluator: 'Бахоловчига бириктирилган сана',
                    confirmedDate: 'Тугатилган сана',
                    agent: 'Агент',
                    buildingType: 'Категория',
                    subBuildingType: 'Суб категория',
                    landComparison: 'Ер участкаси калкуляция',
                    mfy: "МФЙ",
                    microRegionSelected: "Мўлжални танлаш"
                }
            },
            comparativeError: {
                notorious: {
                    code: 'НK',
                    label: 'Нотурар жой хатолик руйхати'
                },
                residential: {
                    code: 'ТK',
                    label: 'Турар жой хатолик руйхати'
                }
            }
        },
        tender: {
            name: 'Тендерлар',
            title: 'Тендер савдолари бўйича кўрсатилган хизмат учун Ҳудудий рахбарларга бериладиган хақ',
            title2: 'Идентификация килиш ишлари учун таъриф',
            titleListTypeWork: 'Бажариладиган иш тури',
            titleListPriceCity: 'Шахар худуди буйича (сўм)',
            titleListPriceDistrict: 'Туман худуди буйича (сўм)',
            description: 'Изох',
            delivereEnvelope: 'Конверт топшириш',
            tenderParticipation: 'Тендерда иштирок этиш ва транспорт харажат',
            concludingContract: 'Шартнома тузиш',
            realEstate: 'Кўчмас мулк',
            fitment: 'Бошка турдаги мол мулклар',
            auto: 'Автомототранспорт воситаси',
            addEbaholash: 'Дастурга киритиш',
            printEbaholash: 'Бахолаш хулосасини чикариш',
            calculation: 'Ҳисоб-китоб',
            users: 'Ходимлар',
            validation: {
                buildingType: 'Илтимос фойдаланиш мақсадини танланг',
                repairCondition: 'Илтимос таъмир холатини танланг',
                wall: 'Илтимос қурилиш турини киритинг'
            }
        },
        regionalLeader: {
            code: 'RL',
            titleList: 'Худудий рахбар рўйхати',
            addNew: "Худудий рахбар қўшиш",
            fullName: 'И.Ф.О',
            province: 'Вилоят',
            address: 'Манзили',
            description: 'Изох',
            internalPhoneNumber: 'внутренний номер телефона',
            successSaved: 'Худудий рахбар муваффақиятли сақланди',
        },
        companyTariff: {
            listTitle: "Компаниялар тарифлари рўйхати",
            addNew: "Компаниялар тарифини қўшиш",
            titleEdit: 'Компаниялар тарифини ўзгартириш',
            companyTariffType: "Тариф тури",
            name: "Номи",
            qty: "Микдори",
            amount: "Суммаси",
            measurementType: "Ўлчов бирлиги",
            description: "Изох"
        },
        companyManage: {
            title: "Компания Бошкариш",
            companyPersonalCabinet: {
                code: 'CM',
                label: 'Компания шахсий кабинети',
            },
            companyOrder: {
                title: 'Компаниялар пакетлар рўйхати',
                feeService: 'Хизмат хакки (сўм)',
                paidAmount: 'Туланган сумма (сўм)',
                addNew: "Хизматга Буютма бериш",
                edit: "Хизматни узгартириш",
                tariff: 'Тариф',
                companyClient: 'Клиент компании',
                contractNumber: 'Шартнома раками',
                addTariff: 'Тариф қўшиш',
                editTariff: 'Тариф ўзгартириш',
                addPieceSale: 'Штучный қўшиш',
                editPieceSale: 'Штучный ўзгартириш'
            }
        },
        depositSalary: {
            title: "Иш ҳақи Депозитлари",
            appraiserSalary: {
                label: 'Бахоловчилар иш ҳақи',
                code: '',
                addTitle: 'Бахоловчилар иш ҳақини қўшиш',
                editTitle: 'Бахоловчилар иш ҳақини ўзгартириш',
                addNewDepositSalary: "Иш ҳақини депозитга кўчириш ",
                appraiser: 'Бахоловчи',
                maxDepositAmount: " сўмдан кўп депозит киритиш мумкин эмас",
            },
            usersSalary: {
                label: 'Ходимлар иш ҳақи',
                code: '',
                paidAmount: 'Туланган сумма (сўм)',
                addTitle: 'Ходимлар иш ҳақини қўшиш',
                editTitle: 'Ходимлар иш ҳақини ўзгартириш',

            }
        },
        userBalancePaymentTransaction: {
            title: "Фойдаланувчи балансидан тўлов",
            contractNumber: "Контракт номер",
            summa: "Сумма",
            payer: "Туловчи",
            objectId: "Object Id",
            objectName: "Объекта номи",
            smsSend: "Sms Юбориш",
            inputSmsCode: "Sms Code",
            pay: "Тулаш"
        },

        paymentBalance: {
            title: "Балансидан тўлов",
            contractNumber: "Контракт номер",
            summa: "Сумма",
            payer: "Туловчи",
            objectId: "Бахоловчи бахолаган объект раками",
            objectName: "Объекта номи",
            smsSend: "Sms Юбориш",
            inputSmsCode: "Sms Code",
            pay: "Тулаш"

        },
        finance2: {
            name: 'Finance 2',
            universalBank: {
                titleListCredit: 'Universal Bank Кредит трансакциялар рўйхати',
                titleListDebit: 'Universal Bank Дебет трансакциялар рўйхати',
                titleTransactionList: 'Universal Bank тўлов транзакциялар рўйхати',
                titleListFixedReadyTransferExpenses: 'Доимий харажатлар учун трансакциялар рўйхати (ойлик, хафтлик)',
                getBalance: 'Хисоб рақамлардаги қолдиқни кўриш',
                balanceAccount: 'Хисоб рақамлардаги қолдиқ',
                balanceAccountsConfirm: 'Сиз ҳақиқатдан ҳам қолдиқни кўрмоқчимисиз?',
                getAccountTransactionConfirm: 'Сиз ҳақиқатдан ҳам бу трансакцияни юклаш қилмоқчимисиз?',
                transaction: {
                    debit: {
                        code: 'UBT',
                        label: 'Universal Bank Дебет',
                        action: {
                            getAccountDebit: 'Дебет транзакцияларни юклаб олиш'
                        }
                    },
                    credit: {
                        code: 'UBT',
                        label: 'Universal Bank Кредит',
                        action: {
                            getAccountCredit: 'Кредит транзакцияларни юклаб олиш',
                            rejectTransaction: 'Транзакцияни кайтариш',
                            bindToObject: 'Объект бирлаштириш'
                        }
                    },
                    payment: {
                        code: 'UBT',
                        label: 'Universal Bank тўлов транзакциялар',
                        action: {
                            balanceViewClose: 'Бекор килмок'
                        }
                    },
                    fixedExpenseReadyTransfer: {
                        code: 'UBT',
                        label: 'Доимий харажатлар учун трансакциялар'
                    }
                },
                paymentTransaction: {
                    add: {
                        title: 'Янги тўлов киритиш'
                    }
                },
                field: {
                    contractNumber: 'Шартнома раками',
                    sumPay: 'Сумма (сўм)',
                    docNum: 'DOC_NUMB',
                    docDate: 'DOC_DATE',
                    clMFO: 'CL_MFO',
                    clACC: 'CL_ACC',
                    clINN: 'CL_INN',
                    clName: 'CL_NAME',
                    coName: 'CO_NAME',
                    payPurpose: 'Тўлов максади',
                    action: 'Жараён',
                    payDate: 'Тўлов утказиладиган сана',
                    status: 'Статус',
                    amount: 'Тўлов сўммаси',
                    creditName: 'Кабул килўвчи',
                    creditInn: 'ИНН',
                    account: 'Хисоб ракам',
                    branch: 'МФО',
                    operationType: 'Тип проводки'
                }
            },
            paymentCode: {
                titleList: 'Тулов кодлари рўйхати',
                code: 'UBT',
                label: 'Тулов кодлари'
            }
        },
        expert2: {
            name: 'Эксперт 2',
            titleList: 'Эксперт2 руйхати',
            titleAdd: 'Эксперт2 қўшиш',
            titleEdit: 'Эксперт2 ўзгартириш',
            titleEAppraisalRealEstateView: 'Е-баҳолаш эксперт2 кўчмас мулкни куриш',
            titleEAppraisalAssetView: 'Е-баҳолаш эксперт2 Аралаш мол-мулкни куриш',
            titleFitment: {
                view: 'Е-баҳолаш эксперт2 Асосий воситани кўриш',
                list: 'Онлайн эксперт2 Асосий воситалар руйхати',
            },
            titleAuto: {
                view: 'Е-баҳолаш эксперт2 Автотранспортни кўриш',
                list: 'Онлайн эксперт2 Автотранспортлар руйхати'
            },
            titleLosses: {
                view: 'Е-баҳолаш эксперт2 Етказилган зарарни кўриш',
                list: 'Онлайн эксперт2 Етказилган зарар руйхати'
            },
            list: {
                code: 'E',
                label: 'Эксперт2 руйхати'
            },
            add: {
                title: 'Эксперт2 маълумотларини киритинг'
            },
            edit: {
                title: 'Эксперт2 ўзгартириш',
                assetTitle: 'Эксперт2 Аралаш мол-мулк ўзгартириш'
            },
            field: {
                name: 'Объект номи',
                organizationName: 'Ташкилот номи',
                evlGoalType: "Баҳолаш мақсади",
                userBank: "Банк ходими телефон рақами",
                bankName: "Банк номи",
                deleteConfirm: 'Сиз ҳақиқатдан ҳам ўчириб ташламоқчимисиз?',
                deleteSuccess: 'Муваффақиятли ўчирилди',
                deleteError: 'Ўчиришда хатолик юз берди',
                status: 'Статус',
                action: 'Жараён',
                documents: 'Илова хужжатлари',
                act: 'Эксперт',
                approaches: 'Ёндашувлар',
                orgInn: "ИНН (Бахоловчи ташкилот)",
                owner: "Мулк эгаси",
                ownerInn: 'ИНН (Мулк эгаси)',
                ownerType: {
                    physical: 'Жисмоний шахс',
                    legal: 'Юридик шахс'
                },
                createdDate: "Киритилган сана",
                createdBy: 'Томонидан яратилган',
                province: 'Вилоятни танланг',
                region: 'Туманни танланг',
                address: 'Объект манзили',
                reportNumber: 'Баҳолаш ҳисоботи рўйхатга олиш рақами',
                evlEstimatedDate: 'Баҳоланган сана',
                docsToSubmit: 'Тақдим қилинадиган ҳужжатлар',
                docCadastre: 'Кадастр хужжати нусхаси',
                docReport: 'Бахолаш ҳисоботи нусхаси',
                docPhotos: 'Бино расмлари',
                directorEsp: 'Тастиқлаш',
                buildingCount: 'Кўчмас мулк литрлари сони',
                evlObjectCount: 'Автотранспорт сони',
                fitmentMachinesToolsCount: 'Машина ва асбоб-ускуналар сони',
                fitmentOthersCount: 'Бошка мол-мулклар сони',
                agent: 'Агент',
                assetCoordination: 'Эксперт2 Аралаш мол-мулк мувофиқлаштириш',
                assetToEvaluate: 'Аралаш мол-мулкларни киритинг',
                assetEvaluations: 'Бахоланадиган аралаш мол-мулклар',
                organization: 'Ташкилот'
            },
            validation: {
                reference: {
                    sortOrder: 'Илтимос тартибни киритинг',
                    comment: 'Илтимос хулосани киритинг'
                },
                approachCost: 'Харажат ёндашув тўлдирилмаган!',
                approachComparative: 'Қиёсий ёндашув тўлдирилмаган!',
                approachIncome: 'Даромад ёндашув тўлдирилмаган!',
                organization: 'Ташкилотни танланг!'
            },
            approach: {
                expense: "Харажат ёндашув",
                income: 'Даромад ёндашув',
                comparative: 'Қиёсий ёндашув'
            },
            status: {
                notReady: 'Тайёр эмас',
                pending: 'Хали кўрилмади',
                notFullyEvaluated: 'Жараёнда',
                confirmed: 'Тасдиқланган',
                rejected: 'Бекор қилинган',
                assignedToEvaluator: 'Бахоловчига бириктирилди',
                evaluated: 'Бахоланган',
            },
            calculated: {
                expense: 'Бахолаш объектининг харажат ёндашувида бахолаш натижаси',
                coordination: 'Бахолаш натижаларини мувофиқлаштириш'
            },
            action: {
                finish: 'Тугатиш',
                pending: 'Жўнатиш',
                reject: 'Рад қилиш',
                open: 'Янги',
                inCorrection: 'Тузатишда'
            }
        },
        director: {
            list: {
                code: 'D',
                label: 'Директорлар руйхати'
            },
            listTitle: "Директорлар рўйхати",
            addNew: "Директор қўшиш",
            titleEdit: 'Директор ўзгартириш',
            description: "Изох"
        },
        companyRegistrationCertificate: {
            title: 'Компания руйхатдан ўтказиш тўғрисидаги гувохнома',
            addNew: "Компания руйхатдан ўтказиш тўғрисидаги гувохнома қўшиш",
            fullName: 'Тўлиқ номи',
            shortName: 'Номи',
            registrationDate: 'Руйхатга олиш санаси',
            registrationNumber: 'Руйхатга олинган номери',
            picture: 'Компания руйхатдан ўтказиш тўғрисидаги гувохнома нусхаси',
            address: 'Руйхатга олинган номери',
            givenBy: 'Ким томонидан берилган'
        },
        employees: {
            list: {
                code: 'X',
                label: 'Ходимлар'
            },
            listTitle: "Ходимлар рўйхати",
            addNew: "Ходим қўшиш",
            titleEdit: 'Ходим ўзгартириш',
            description: "Изох"
        },
        appraiserHelpers: {
            list: {
                code: 'Б',
                label: 'Баҳоловчи ёрдамчилари'
            },
            listTitle: "Баҳоловчи ёрдамчилари рўйхати",
            addNew: "Баҳоловчи ёрдамчиси қўшиш",
            titleEdit: 'Баҳоловчи ёрдамчиси ўзгартириш',
            description: "Изох",
            employeeName: 'Исми/Шарифи',
            username: 'Логин',
            mobilePhone: 'Мобил телефон',
            roleNames: 'Мансаби',
            status: 'Статус',
            lastName: 'Фамилияси',
            firstName: 'Исми',
            midName: 'Отасининг исми',
            province: 'Вилояти',
            region: 'Тумани',
            phone: 'Телефон рақами',
            inn: 'ИНН',
            regionalLeaderProvince: 'Худуд Вилояти',
            regionalLeaderRegion: 'Худуд Тумани',
            regionalLeader: 'Худудий рахбари',
            email: 'Е-майл',
            passportNumber: 'Паспорт серияси ва рақами',
            passportDate: 'Паспорт берилган сана',
            passportGivePlace: 'Ким томондан берилган',
            plasticCardNumber: 'Пластик карта номери',
            plasticCardValidTo: 'Пластик карта амал килиш муддати',
            accountNumber: 'Банк хисоб рақами',
            passportFiles: 'Паспорт нусхасини юкланг',
            diplomaFiles: 'Диплом нусхасини юкланг',
        }
    }
}
export default messages;
